<template lang="pug">
  b-container.white-space(fluid="fluid")
    b-row
      b-col
        b-card#plan(:header="plans[value.plan_name || ''].title" class="card font-weight-bold" header-class="plan-title-size text-center card font-weight-bold" footer-tag="footer")
          b-card-text
            b-row.mb-3(align-h="around")
              .mr-3(v-if="plans[value.plan_name || ''].services.includes('neo')")
                img.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
              .mr-3(v-if="plans[value.plan_name || ''].services.includes('appsuite')")
                img.logo_appsuite(src="@/assets/images/logo_appsuite.png")
              .mr-3(v-if="plans[value.plan_name || ''].services.includes('chatluck')")
                img.logo_chatluck(src="@/assets/images/logo_chatluck.png")
            .text-center.mb-3
              h4.font-weight-bold （1ユーザー￥{{plans[value.plan_name || ''].price.toLocaleString()}}/月）
            b-row.mb-3(align-h="center")
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="plan.label", :label-class="plan.label_class")
                .form-inline
                  b-form-input.mb-2.align-content(size="sm", :type="plan.type", v-model="value.plan_user", :placeholder="plan.placeholder", :maxlength="plan.maxlength" @change="optionOpen")
                  b-form-text.ml-1.mb-2 ユーザー
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of plan.error_msg") {{error_msg}}
                b-form-text.description-text-position {{plan.description}}
    b-form-group.align-content(label-cols="3", label-size="sm", style="height: 25px;")
    b-container.neo-b-collapse(v-if="value.plan_name !== 'chatluck'" v-show="!neoIsOpen")
      h2.font-weight-bold desknet's NEOオプションサービス
      b-form-text.mb-4 ※ユーザー数を入力するとオプションサービスのフォームが開きます
      // AppSuite
      h5.font-weight-bold.ml-3.form-inline(v-if="value.plan_name !== 'standard' && value.plan_name !== 'premium'")
        label ・業務アプリ作成ツール AppSuite（1ユーザー￥550/月）
      //- 空行
      b-form-group(v-if="value.plan_name !== 'standard' && value.plan_name !== 'premium'" label-cols="3", label-size="sm", style="height: 5px;")
      // ウェブ会議
      h5.font-weight-bold.ml-3.form-inline
        label ・desknet's NEO ウェブ会議（1会議室￥11,000/月）
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 5px;")
      // オプションサービス
      h5.font-weight-bold.ml-3.form-inline
        label ・オプションサービス
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 5px;")
      // セキュリティオプション
      h5.font-weight-bold.ml-3.form-inline
        label ・セキュリティオプション
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 5px;")
      // メールサービス
      h5.font-weight-bold.ml-3.form-inline
        label ・メールサービス
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 5px")
      // メールセキュリティサービス
      h5.font-weight-bold.ml-3.form-inline
        label ・メールセキュリティサービス
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 25px")
    b-collapse.neo-b-collapse(v-if="value.plan_name !== 'chatluck'" v-model="neoIsOpen")
      h2.font-weight-bold.mb-4 desknet's NEOオプションサービス
      b-row
        b-col
          // AppSuite
          h5.font-weight-bold.ml-3.form-inline#app-suite-user(v-if="value.plan_name !== 'standard' && value.plan_name !== 'premium'")
            label 業務アプリ作成ツール AppSuite（1ユーザー￥550/月）
            b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/appsuite/", target="_blank") 詳細はこちら ＞
          b-form-group.align-content(v-if="value.plan_name !== 'standard' && value.plan_name !== 'premium'" label-cols="3", label-align="right", label-size="sm", :label="app_suite.label", :label-class="app_suite.label_class")
            .form-inline
              b-form-input.mb-2(size="sm", :type="app_suite.type", v-model="value.app_suite_user", :placeholder="app_suite.placeholder", :state="app_suite.error_msg.length === 0 ? null : false")
              b-form-text.ml-1.mb-2 ユーザー
            //b-form-text.error-text-position.mb-1(text-variant="danger") 5以上を入力してください
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of app_suite.error_msg") {{error_msg}}
            b-form-text.description-text-position {{app_suite.description}}
          //- 空行
          b-form-group(v-if="value.plan_name !== 'standard' && value.plan_name !== 'premium'" label-cols="3", label-size="sm", style="height: 25px;")
          // ウェブ会議
          h5.font-weight-bold.ml-3.form-inline#web-conferencing
            label desknet's NEO ウェブ会議（1会議室￥11,000/月）
            b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/webmtg/", target="_blank") 詳細はこちら ＞
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="web_conferencing.label", :label-class="web_conferencing.label_class")
            .form-inline
              b-form-input.mb-2(size="sm", :type="web_conferencing.type", v-model="value.web_conferencing", :placeholder="web_conferencing.placeholder", :state="web_conferencing.error_msg.length === 0 ? null : false")
              b-form-text.ml-1.mb-2 会議室
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of web_conferencing.error_msg") {{error_msg}}
            b-form-text.description-text-position {{web_conferencing.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
          //- オプションサービス
          h5.font-weight-bold.ml-3.mb-3#neo-option-service
            b-form-checkbox(v-model="value.option_service", @change="toggleOptionService") オプションサービス
          b-collapse#collapse-option-service(v-model="optionServiceIsOpen")
            //- RoomMgr
            b-form-checkbox.ml-4(v-model="value.option_room_mgr")
              .form-inline
                b-form-text.label-font-size.mt-0 {{option_room_mgr.label}}
                b-button.detail-button-size(
                  size="sm",
                  variant="primary",
                  href="https://www.desknets.com/neo/features/roommgr/",
                  target="_blank"
                ) 詳細はこちら ＞
              b-form-text.error-message-color(v-for="(error_msg) of option_room_mgr.error_msg") {{error_msg}}
            b-form-text.ml-5 {{option_room_mgr.description}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            // 交通費・経費精算
            b-form-checkbox.ml-4(v-model="value.option_expense_settlement")
              .form-inline
                b-form-text.label-font-size.mt-0 {{option_expense_settlement.label}}
                b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/releases/v30/feature1.html", target="_blank") 詳細はこちら ＞
              b-form-text {{option_expense_settlement.description}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            // タイムカード＋CLOUZA
            .form-inline
              b-form-checkbox.ml-4(:state="clouza_check.error_msg.length === 0 ? null : false", v-model="value.clouza_check", @change="toggleClouza") {{clouza_check.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/timecardp/", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.error-message-color(v-for="(error_msg) of clouza_check.error_msg") {{error_msg}}
            b-collapse#collapse-option-clouza.sub-b-collapse(v-model="optionClouzaIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="clouza_input.label", :label-class="clouza_input.label_class")
                .form-inline
                  b-form-input(size="sm", :type="clouza_input.type", v-model="value.clouza_input", :placeholder="clouza_input.placeholder", :state="clouza_input.error_msg.length === 0 ? null : false")
                  b-form-text.ml-1.mb-2 ユーザー
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of clouza_input.error_msg") {{error_msg}}
                b-form-text.mt-0 {{clouza_input.description}}
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="clouza_company_code.label", :label-class="clouza_company_code.label_class")
                b-form-input(size="sm", :type="clouza_company_code.type", v-model="value.clouza_company_code", :placeholder="clouza_company_code.placeholder", :state="clouza_company_code.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of clouza_company_code.error_msg") {{error_msg}}
                b-form-text.mt-0 {{clouza_company_code.description}}
              b-form-checkbox.mb-2.ml-3.paid-leave-option-font(v-model="value.paid_leave_option", size="sm", :state="paid_leave_option.error_msg.length === 0 ? null : false") {{paid_leave_option.label}}
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of paid_leave_option.error_msg") {{error_msg}}
                b-form-text.description-text-position.paid-leave-option-description-font {{paid_leave_option.description}}
              p.mb-2.ml-3
                a(
                  href="https://www.desknets.com/neo/pdf/article_timecardp.pdf",
                  target="_blank"
                ) ＞ タイムカード＋CLOUZA利用約款
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            //- ディスク増設
            .form-inline
              b-form-checkbox.ml-4(v-model="value.option_disk", @change="toggleDisk") {{option_disk.label}}
            b-collapse#collapse-option-disk.sub-b-collapse(v-model="optionDiskIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="option_disk_size.label", :label-class="option_disk_size.label_class")
                .form-inline
                  b-form-text.mb-2.mx-1 20GB ×
                  b-form-input.mb-2.option-disk-form-class(size="sm", :type="option_disk_size.type", v-model="value.option_disk_size", :state="option_disk_size.error_msg.length === 0 ? null : false", @input="changeSumSize")
                  b-form-text.mb-2.mx-1 =
                  b-form-text.mb-2.mx-1 {{option_disk_sum}}GB 増設
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of option_disk_size.error_msg") {{error_msg}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            //- Sync for smartphones
            .form-inline
              b-form-checkbox.ml-4(v-model="value.option_sync", @change="toggleSync") {{option_sync.label}}
                b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/sync/", target="_blank") 詳細はこちら ＞
            b-collapse#collapse-option-disk.sub-b-collapse(v-model="optionSyncIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="option_sync_input.label", :label-class="option_sync_input.label_class")
                .form-inline
                  b-form-input.mb-2(size="sm", :type="option_sync_input.type", v-model="value.option_sync_input", :placeholder="option_sync_input.placeholder", :state="option_sync_input.error_msg.length === 0 ? null : false")
                  b-form-text.ml-1.mb-2 ユーザー
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of option_sync_input.error_msg") {{error_msg}}
                b-form-text.mt-0 {{option_sync_input.description}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            //- desknet'sドライブ ディスク増設
            .form-inline
              b-form-checkbox.ml-4(v-model="value.option_dn_drive", @change="toggleDnDrive") {{option_dn_drive.label}}
            b-collapse#collapse-option-disk.sub-b-collapse(v-model="optionDnDriveIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="option_dn_drive_disk_size.label", :label-class="option_dn_drive_disk_size.label_class")
                .form-inline
                  b-form-text.mb-2.mx-1 20GB ×
                  b-form-input.mb-2.option-disk-form-class(size="sm", :type="option_dn_drive_disk_size.type", v-model="value.option_dn_drive_disk_size", :state="option_dn_drive_disk_size.error_msg.length === 0 ? null : false", @input="driveChangeSumSize")
                  b-form-text.mb-2.mx-1 =
                  b-form-text.mb-2.mx-1 {{option_dn_drive_disk_sum}}GB 増設
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of option_dn_drive_disk_size.error_msg") {{error_msg}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
          //- セキュリティオプション
          h5.font-weight-bold.ml-3.mb-3#neo-security-option
            b-form-checkbox(v-model="value.security_option", @change="toggleSecurityOption") セキュリティオプション
          b-collapse#collapse-security-option(v-model="securityOptionIsOpen")
            // BASIC認証
            .form-inline
              b-form-checkbox.ml-4(:state="basic_auth.error_msg.length === 0 ? null : false", v-model="value.basic_auth", @change="toggleBasic") {{basic_auth.label}}
            b-form-text.ml-3.align-left.text-left.error-message-color(v-for="(error_msg) of basic_auth.error_msg") {{error_msg}}
            b-collapse#collapse-basic.sub-b-collapse(v-model="basicIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="basic_auth_user.label", :label-class="basic_auth_user.label_class")
                .form-inline
                  b-form-input(size="sm", :type="basic_auth_user.type", v-model="value.basic_auth_user", :placeholder="basic_auth_user.placeholder", :state="basic_auth_user.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of basic_auth_user.error_msg") {{error_msg}}
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="basic_auth_password.label", :label-class="basic_auth_password.label_class")
                .form-inline
                  b-form-input(size="sm", :type="basic_auth_password.type", v-model="value.basic_auth_password", :placeholder="basic_auth_password.placeholder", :state="basic_auth_password.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of basic_auth_password.error_msg") {{error_msg}}
              b-form-group.white-space.align-content.mt-2(label-cols="12", label-align="left", label-size="sm", :label="basic_auth_ip.label", :label-class="basic_auth_ip.label_class")
                b-form-textarea(:state="basic_auth_ip.error_msg.length === 0 ? null : false", v-model="value.basic_auth_ip", rows="4")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of basic_auth_ip.error_msg") {{error_msg}}
                b-form-text.mt-0 {{basic_auth_ip.description}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            // 接続元IPアドレス制限
            .form-inline
              b-form-checkbox.ml-4(:state="ip_restrictions.error_msg.length === 0 ? null : false", v-model="value.ip_restrictions", @change="toggleIpRestrictions") {{ip_restrictions.label}}
              b-form-text.ml-3.align-left.text-left.error-message-color(v-for="(error_msg) of ip_restrictions.error_msg") {{error_msg}}
            b-collapse#collapse-ip-restrictions.sub-b-collapse(v-model="ipRestrictionsIsOpen")
              b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="ip_restrictions_ip.label", :label-class="ip_restrictions_ip.label_class")
                b-form-textarea(:state="ip_restrictions_ip.error_msg.length === 0 ? null : false", v-model="value.ip_restrictions_ip", rows="4")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of ip_restrictions_ip.error_msg") {{error_msg}}
                b-form-text.mt-0 {{ip_restrictions_ip.description}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            // セキュアブラウザ
            //.form-inline
              b-form-checkbox.ml-4(:state="secure_browser.error_msg.length === 0 ? null : false", v-model="value.secure_browser", @change="toggleSecureBrowser") {{secure_browser.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/cloud/sb/", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.error-message-color(v-for="(error_msg) of secure_browser.error_msg") {{error_msg}}
            //b-collapse#collapse-secure-browser.sub-b-collapse(v-model="secureBrowserIsOpen")
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="secure_browser_terminal.label", :label-class="secure_browser_terminal.label_class")
                b-form-radio-group(v-model="value.secure_browser_terminal", :stacked="true", @change="secureBrowserTerminalChange")
                  b-form-radio.m-1(:value="secure_browser_terminal.options[0].value") {{secure_browser_terminal.options[0].text}}
                    b-form-text {{secure_browser_terminal.options[0].description}}
                  b-form-radio.m-1(:value="secure_browser_terminal.options[1].value") {{secure_browser_terminal.options[1].text}}
                    b-form-text {{secure_browser_terminal.options[1].description}}
                .form-inline
                  b-form-input.mb-2(size="sm", :type="secure_browser_device.type", :disabled="secureBrowserTerminalDisabled", v-model="value.secure_browser_device", :placeholder="secure_browser_device.placeholder", :state="secure_browser_device.error_msg.length === 0 ? null : false")
                  b-form-text.ml-1.mb-2 デバイス
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of secure_browser_device.error_msg") {{error_msg}}
              b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="secure_browser_ip.label", :label-class="secure_browser_ip.label_class", :state="secure_browser_ip.error_msg.length === 0 ? null : false")
                b-form-textarea(:state="secure_browser_ip.error_msg.length === 0 ? null : false", v-model="value.secure_browser_ip", rows="4")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of secure_browser_ip.error_msg") {{error_msg}}
                b-form-text.mt-0 {{secure_browser_ip.description}}
            //- 空行
            //b-form-group(label-cols="3", label-size="sm", styl="height: 10px")
            // クライアント認証
            .form-inline
              b-form-checkbox.ml-4(:state="client_auth.error_msg.length === 0 ? null : false", v-model="value.client_auth", @change="toggleClientAuth") {{client_auth.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/clientcert/", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.error-message-color(v-for="(error_msg) of client_auth.error_msg") {{error_msg}}
            b-collapse#collapse-client-auth.sub-b-collapse(v-model="clientAuthIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="client_auth_input.label", :label-class="client_auth_input.label_class")
                .form-inline
                  b-form-input(size="sm", :type="client_auth_input.type", v-model="value.client_auth_input", :placeholder="client_auth_input.placeholder", :state="client_auth_input.error_msg.length === 0 ? null : false")
                  b-form-text.ml-1.mb-2 デバイス
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of client_auth_input.error_msg") {{error_msg}}
                b-form-text.mt-0 {{client_auth_input.description}}
              b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="client_auth_ip.label", :label-class="client_auth_ip.label_class")
                b-form-textarea(:state="client_auth_ip.error_msg.length === 0 ? null : false", v-model="value.client_auth_ip", rows="4")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of client_auth_ip.error_msg") {{error_msg}}
                b-form-text.mt-0 {{client_auth_ip.description}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px")
            b-form-text.ml-4 ※併用できるセキュリティオプションサービスは、Basic認証と接続元IPアドレス制限のみとなります。
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
          //- メールサービス
          h5.font-weight-bold.ml-3.mb-3#neo-mail-service
            b-form-checkbox(v-model="value.mail_service", @change="toggleMailService")
              h5.font-weight-bold {{mail_service.label}}
          b-collapse#collapse-mail-service(v-model="mailServiceIsOpen")
            // WebARENA
            .form-inline
              b-form-checkbox.ml-4(v-model="value.web_arena", @change="toggleWebArena") {{web_arena.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/mail/", target="_blank") 詳細はこちら ＞
            b-collapse#collapse-web-arena.sub-b-collapse(v-model="webArenaIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="web_arena_domain.label", :label-class="web_arena_domain.label_class")
                .form-inline
                  b-form-input(size="sm", :type="web_arena_domain.type", v-model="value.web_arena_domain", :placeholder="web_arena_domain.placeholder", :state="web_arena_domain.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of web_arena_domain.error_msg") {{error_msg}}
                b-form-text.mt-0 {{web_arena_domain.description}}
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="web_arena_input.label", :label-class="web_arena_input.label_class")
                .form-inline
                  b-form-input(size="sm", :type="web_arena_input.type", v-model="value.web_arena_input", :placeholder="web_arena_input.placeholder", :state="web_arena_input.error_msg.length === 0 ? null : false")
                  b-form-text.ml-1.mb-2 アカウント
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of web_arena_input.error_msg") {{error_msg}}
                b-form-text.mt-0 {{web_arena_input.description}}
              p.mb-2.ml-3
                a(
                  href="https://www.desknets.com/cloud/article_cloudmail.pdf",
                  target="_blank"
                ) ＞ WebARENA利用約款
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            // CYBERMAILΣ
            .form-inline
              b-form-checkbox.ml-4(v-model="value.cyber", @change="toggleCyber") {{cyber.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.error-message-color(v-for="(error_msg) of cyber.error_msg") {{error_msg}}
            b-collapse#collapse-cyber.sub-b-collapse(v-model="cyberIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="cyber_input.label", :label-class="cyber_input.label_class")
                .form-inline
                  b-form-input(size="sm", :type="cyber_input.type", v-model="value.cyber_input", :placeholder="cyber_input.placeholder", :state="cyber_input.error_msg.length === 0 ? null : false")
                  b-form-text.ml-1.mb-2 アカウント
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of cyber_input.error_msg") {{error_msg}}
                b-form-text.mt-0 {{cyber_input.description}}
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="cyber_capacity.label", :label-class="cyber_capacity.label_class")
                .form-inline
                  b-form-select(v-model="value.cyber_capacity", :options="cyber_capacity.options", value-field="value", text-field="name", size="sm", :state="cyber_capacity.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of cyber_capacity.error_msg") {{error_msg}}
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="cyber_option.label", :label-class="cyber_option.label_class")
                b-form-checkbox(:state="cyber_option.error_msg.length === 0 ? null : false", v-model="value.cyber_option[0]") {{cyber_option.options[0].label}}
                b-form-text {{cyber_option.options[0].description}}
                b-form-checkbox.mt-3(:state="cyber_option.error_msg.length === 0 ? null : false", v-model="value.cyber_option[1]") {{cyber_option.options[1].label}}
                b-form-text {{cyber_option.options[1].description}}
                b-form-checkbox.mt-3(:state="cyber_option.options[2].error_msg.length === 0 ? null : false", v-model="value.cyber_option[2]") {{cyber_option.options[2].label}}
                b-collapse(v-model="value.cyber_option[2]")
                  .form-inline
                    b-form-select.mt-1.ml-3(v-model="value.cyber_keep_period", :options="cyber_option.options[2].options", value-field="value", text-field="name", size="sm")
                    b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of cyber_option.options[2].error_msg") {{error_msg}}
                b-form-checkbox.mt-3(v-model="value.cyber_option[3]") {{cyber_option.options[3].label}}
                .form-inline
                  p.mt-3 {{cyber_option.options[3].description_1}}
                  a(href="https://www.desknets.com/neo/inquiry/", target="_blank") お問合せ
                  p {{cyber_option.options[3].description_2}}
              p.mb-2.ml-3
                a(
                  href="https://www.cybersolutions.co.jp/admission/admission-CYBERMAILSIGMA.pdf",
                  target="_blank"
                ) ＞ CYBERMAILΣ利用約款
              b-form-text.align-left.text-left.ml-4.error-message-color(v-for="(error_msg) of cyber_option.error_msg") {{error_msg}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px")
            b-form-text.ml-4 ※メールサービスは、メールサーバーのクラウド化をご希望のお客さま向けのオプションサービスです。
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 10px")
          //- メールセキュリティサービス
          h5.font-weight-bold.ml-3.mb-3#neo-mail-security-service
            b-form-checkbox(v-model="value.mail_security_service", @change="toggleMailSecurityService")
              h5.font-weight-bold {{mail_security_service.label}}
          b-collapse#collapse-mail-service(v-model="mailSecurityServiceIsOpen")
            // MAILGATES Σ
            .form-inline
              b-form-checkbox.ml-4(v-model="value.mailgates", @change="toggleMailgates") {{mailgates.label}}
              b-button.detail-button-size(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/#mailgates", target="_blank") 詳細はこちら ＞
              b-form-text.ml-3.error-message-color(v-for="(error_msg) of mailgates.error_msg") {{error_msg}}
            b-collapse#collapse-mailgates.sub-b-collapse(v-model="mailgatesIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="mailgates_domain.label", :label-class="mailgates_domain.label_class")
                .form-inline
                  b-form-input(size="sm", :type="mailgates_domain.type", v-model="value.mailgates_domain", :placeholder="mailgates_domain.placeholder", :state="mailgates_domain.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of mailgates_domain.error_msg") {{error_msg}}
                b-form-text.mt-0 {{mailgates_domain.description}}
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="mailgates_input.label", :label-class="mailgates_input.label_class")
                .form-inline
                  b-form-input(size="sm", :type="mailgates_input.type", v-model="value.mailgates_input", :placeholder="mailgates_input.placeholder", :state="mailgates_input.error_msg.length === 0 ? null : false")
                  b-form-text.ml-1.mb-2 アカウント
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of mailgates_input.error_msg") {{error_msg}}
                b-form-text.mt-0 {{mailgates_input.description}}
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="mailgates_option.label", :label-class="mailgates_option.label_class")
                b-form-checkbox(:state="mailgates_option.error_msg.length === 0 ? null : false", v-model="value.mailgates_option[0]") {{mailgates_option.options[0].label}}
                b-form-text {{mailgates_option.options[0].description}}
                b-form-checkbox.mt-3(:state="mailgates_option.error_msg.length === 0 ? null : false", v-model="value.mailgates_option[1]") {{mailgates_option.options[1].label}}
                b-form-text(text-variant="danger") {{mailgates_option.options[1].caution}}
                b-form-text {{mailgates_option.options[1].description}}
                b-form-checkbox.mt-3(:state="mailgates_option.error_msg.length === 0 ? null : false", v-model="value.mailgates_option[2]") {{mailgates_option.options[2].label}}
                b-form-text(text-variant="danger") {{mailgates_option.options[2].caution}}
                b-form-text {{mailgates_option.options[2].description}}
              p.mb-2.ml-3
                a(
                  href="https://www.cybersolutions.co.jp/admission/admission-MAILGATESSIGMA.pdf",
                  target="_blank"
                ) ＞ MAILGATES Σ利用約款
              b-form-text.align-left.text-left.ml-4.error-message-color(v-for="(error_msg) of mailgates_option.error_msg") {{error_msg}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px")
            b-form-text.ml-4 ※メールセキュリティサービスは、ゲートウェイ型のメールセキュリティ対策をご希望のお客さま向けのオプションサービスです。
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
          // ご希望サブドメイン名
          h5.font-weight-bold.ml-3#neo-sub-domain ご希望サブドメイン名
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="sub_domain.label", :label-class="sub_domain.label_class")
            .form-inline
              b-form-input.mb-2(size="sm", :type="sub_domain.type", v-model="value.sub_domain", :state="sub_domain.error_msg.length === 0 ? null : false", @change="domainCheck('neo')")
              b-form-text.ml-1.mb-2 .dn-cloud.com
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of sub_domain.error_msg") {{error_msg}}
            b-form-text.description-text-position {{sub_domain.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
          // 無料お試し版からのデータ移行
          h5.font-weight-bold.ml-3#neo-migration-url 無料お試し版からのデータ移行
          b-form-checkbox.ml-4(v-model="value.migration", @change="toggleMigration", :state="migration.error_msg.length === 0 ? null : false")
            .form-inline
              b-form-text.label-font-size.mt-0 {{migration.label}}
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of migration.error_msg") {{error_msg}}
            b-form-text.font-weight-bold(text-variant="danger") {{migration.description}}
          b-collapse#collapse-migration.sub-b-collapse(v-model="migrationIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="migration_url.label", :label-class="migration_url.label_class")
              b-form-input(size="sm", type="text", v-model="value.migration_url", :placeholder="migration_url.placeholder", :state="migration_url.error_msg.length === 0 ? null : false", maxlength="128")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of migration_url.error_msg") {{error_msg}}
              //.form-inline
              //  b-form-text 試使用環境のURLをコピーする方法は
              //  b-link(href="/migration_help.html", style="font-size: 80%; margin-top: 4px;", target="_blank") こちら
              //  b-form-text から
            //b-form-group.white-space.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="migration_choice.label", :label-class="migration_choice.label_class")
              .form-inline
                b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
                b-modal#select_datetime.my-modal(centered, ok-only, size="xl", title='作業日時選択', @ok="setDateTime", @hide="resetDateTime")
                  select-datetime(v-model="migration_datetime.value_tmp")
            //b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="migration_datetime.label", :label-class="migration_datetime.label_class")
              b-form-text.mb-2.datetime-text {{showMigrationTime}}
              b-form-text.mb-2.datetime-text(v-show="!date_selected") 選択してください
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of migration_datetime.error_msg") {{error_msg}}
              b-form-text.mb-2.datetime-text(v-show="date_selected") {{migration_datetime.value}}
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 25px")
    b-container.chat-b-collapse(v-if="value.plan_name !== 'light' && value.plan_name !== 'standard'" v-show="!chatIsOpen")
      h2.font-weight-bold ChatLuckオプションサービス
      b-form-text.mb-4 ※ユーザー数を入力するとオプションサービスのフォームが開きます
      // オプションサービス
      h5.font-weight-bold.ml-3.form-inline
        label ・オプションサービス
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 5px;")
      // セキュリティオプション
      h5.font-weight-bold.ml-3.form-inline
        label ・セキュリティオプション
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
    b-collapse.chat-b-collapse(v-if="value.plan_name !== 'light' && value.plan_name !== 'standard'" v-model="chatIsOpen")
      h2.font-weight-bold.mb-4 ChatLuckオプションサービス
      b-row
        b-col
          // オプションサービス
          h5.font-weight-bold.ml-3.mb-3#chat-option-service
            b-form-checkbox(v-model="value.chat_option_service", @change="toggleChatOptionService") オプションサービス
          b-collapse(v-model="chatOptionServiceIsOpen")
            // ディスク増設
            .form-inline
              b-form-checkbox.ml-4(v-model="value.chat_option_disk", @change="toggleChatDisk") {{chat_option_disk.label}}
            b-collapse.sub-b-collapse(v-model="chatOptionDiskIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="chat_option_disk_size.label", :label-class="chat_option_disk_size.label_class")
                .form-inline
                  b-form-text.mb-2.mx-1 20GB ×
                  b-form-input.mb-2.option-disk-form-class(size="sm", :type="chat_option_disk_size.type", v-model="value.chat_option_disk_size", :state="chat_option_disk_size.error_msg.length === 0 ? null : false", @input="chatChangeSumSize")
                  b-form-text.mb-2.mx-1 =
                  b-form-text.mb-2.mx-1 {{chat_option_disk_sum}}GB 増設
                b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of chat_option_disk_size.error_msg") {{error_msg}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
          // セキュリティオプション
          h5.font-weight-bold.ml-3.mb-3#chat-security-option
            b-form-checkbox(v-model="value.chat_security_option", @change="toggleChatSecurityOption") セキュリティオプション
          b-collapse(v-model="chatSecurityOptionIsOpen")
            // BASIC認証
            .form-inline
              b-form-checkbox.ml-4(v-model="value.chat_basic_auth", @change="toggleChatBasic") {{chat_basic_auth.label}}
            b-collapse.sub-b-collapse(v-model="chatBasicIsOpen")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="chat_basic_auth_user.label", :label-class="chat_basic_auth_user.label_class")
                .form-inline
                  b-form-input(size="sm", :type="chat_basic_auth_user.type", v-model="value.chat_basic_auth_user", :placeholder="chat_basic_auth_user.placeholder", :state="chat_basic_auth_user.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of chat_basic_auth_user.error_msg") {{error_msg}}
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="chat_basic_auth_password.label", :label-class="chat_basic_auth_password.label_class")
                .form-inline
                  b-form-input(size="sm", :type="chat_basic_auth_password.type", v-model="value.chat_basic_auth_password", :placeholder="chat_basic_auth_password.placeholder", :state="chat_basic_auth_password.error_msg.length === 0 ? null : false")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of chat_basic_auth_password.error_msg") {{error_msg}}
              b-form-group.white-space.align-content.mt-2(label-cols="12", label-align="left", label-size="sm", :label="chat_basic_auth_ip.label", :label-class="chat_basic_auth_ip.label_class")
                b-form-textarea(:state="chat_basic_auth_ip.error_msg.length === 0 ? null : false", v-model="value.chat_basic_auth_ip", rows="4")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of chat_basic_auth_ip.error_msg") {{error_msg}}
                b-form-text.mt-0 {{chat_basic_auth_ip.description}}
            //- 空行
            b-form-group(label-cols="3", label-size="sm", style="height: 10px;")
            // 接続元IPアドレス制限
            .form-inline
              b-form-checkbox.ml-4(:state="chat_ip_restrictions.error_msg.length === 0 ? null : false", v-model="value.chat_ip_restrictions", @change="toggleChatIpRestrictions") {{chat_ip_restrictions.label}}
              b-form-text.ml-3.text-left.error-message-color(v-for="(error_msg) of chat_ip_restrictions.error_msg") {{error_msg}}
            b-collapse.sub-b-collapse(v-model="chatIpRestrictionsIsOpen")
              b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="chat_ip_restrictions_ip.label", :label-class="chat_ip_restrictions_ip.label_class")
                b-form-textarea(:state="chat_ip_restrictions_ip.error_msg.length === 0 ? null : false", v-model="value.chat_ip_restrictions_ip", rows="4")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of chat_ip_restrictions_ip.error_msg") {{error_msg}}
                b-form-text.mt-0 {{chat_ip_restrictions_ip.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
          // ご希望サブドメイン名
          h5.font-weight-bold.ml-3#chat-sub-domain ご希望サブドメイン名
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="chat_sub_domain.label", :label-class="chat_sub_domain.label_class", :state="chat_sub_domain.error_msg.length === 0 ? null : false")
            .form-inline
              b-form-input.mb-2(size="sm", :type="chat_sub_domain.type", v-model="value.chat_sub_domain", :state="chat_sub_domain.error_msg.length === 0 ? null : false", @change="domainCheck('chat')")
              b-form-text.ml-1.mb-2 .chatluck.net
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of chat_sub_domain.error_msg") {{error_msg}}
            b-form-text.description-text-position {{chat_sub_domain.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
          // 無料お試し版からのデータ移行
          h5.font-weight-bold.ml-3#chat-migration-url 無料お試し版からのデータ移行
          b-form-checkbox.ml-4(v-model="value.chat_migration", @change="toggleChatMigration")
            .form-inline
              b-form-text.label-font-size.mt-0 {{chat_migration.label}}
            b-form-text.font-weight-bold(text-variant="danger") {{chat_migration.description}}
          b-collapse.sub-b-collapse(v-model="chatMigrationIsOpen")
            b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="chat_migration_url.label", :label-class="chat_migration_url.label_class")
              b-form-input(size="sm", type="text", v-model="value.chat_migration_url", :placeholder="chat_migration_url.placeholder", :state="chat_migration_url.error_msg.length === 0 ? null : false", maxlength="128")
              b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of chat_migration_url.error_msg") {{error_msg}}
              //.form-inline
              //  b-form-text 試使用環境のURLをコピーする方法は
              //  b-link(href="/migration_help.html", style="font-size: 80%; margin-top: 4px;", target="_blank") こちら
              //  b-form-text から
            //b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="chat_migration_choice.label", :label-class="chat_migration_choice.label_class")
              .form-inline
                b-button.mb-2(v-b-modal.chat_select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
                b-modal#chat_select_datetime.my-modal(centered, ok-only, size="xl", title='作業日時選択', @ok="setChatDateTime", @hide="resetChatDateTime")
                  select-datetime(v-model="chat_migration_datetime.value_tmp")
            //b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="chat_migration_datetime.label", :label-class="chat_migration_datetime.label_class")
              b-form-text.mb-2.datetime-text {{showChatMigrationTime}}
          //- 空行
          //b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
          // ご利用開始希望日
          //h5#chat-preferred-date.font-weight-bold.ml-3 ご利用開始希望日
          //b-form-group.align-contet(label-cols="3", label-align="right", label-size="sm", :label="chat_preferred_date.label", :label-class="chat_preferred_date.label_class")
            b-form-datepicker.mb-2.datepicker-size(size="sm", v-model="chat_preferred_date.value", :min="chat_preferred_date.min", :placeholder="chat_preferred_date.placeholder", :hide-header="true", :date-format-options="chat_preferred_date.format_option")
            b-form-text.description-text-position {{chat_preferred_date.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
      //- 空行
      b-form-group(label-cols="3", label-size="sm", style="height: 25px;")
    b-row
      b-col
        b-collapse(v-model="anyIsOpen")
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
          // 無料お試し版からのデータ移行作業日時
          //div(v-if="migrationIsOpen === true || chatMigrationIsOpen === true")
            h5.font-weight-bold.ml-3#migration_date 無料お試し版からのデータ移行作業日時
            b-form-text.font-weight-bold.ml-3(text-variant="danger") {{chat_migration.description}}
            .sub-b-collapse
              b-form-group.white-space.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="migration_choice.label", :label-class="migration_choice.label_class")
                .form-inline(v-if="migrationIsOpen === true && chatMigrationIsOpen === true")
                  b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
                  b-modal#select_datetime.my-modal(centered, ok-only, size="xl", title='作業日時選択', @ok="setDateTime", @hide="resetDateTime")
                    select-datetime-double(v-model="migration_datetime.value_tmp")
                .form-inline(v-else)
                  b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
                  b-modal#select_datetime.my-modal(centered, ok-only, size="xl", title='作業日時選択', @ok="setDateTime", @hide="resetDateTime")
                    select-datetime(v-model="migration_datetime.value_tmp")
              b-form-group.align-content.mt-2(label-cols="3", label-align="right", label-size="sm", :label="migration_datetime.label", :label-class="migration_datetime.label_class")
                b-form-text.mb-2.datetime-text {{showMigrationTime}}
          div(v-if="(neoIsOpen === true && migrationIsOpen === true) || (chatIsOpen === true && chatMigrationIsOpen === true)")
            h5.font-weight-bold.ml-3#migration-date 無料お試し版からのデータ移行作業日時
            b-form-text.font-weight-bold.ml-3(text-variant="danger") {{migration.description}}
            .sub-b-collapse
              b-form-group.white-space.align-content.mt-2.ml-3(label-cols="5", label-align="right", label-size="sm", :label="migration_choice.label", :label-class="migration_choice.label_class")
                .form-inline(v-if="(neoIsOpen === true && migrationIsOpen === true) && (chatIsOpen === true && chatMigrationIsOpen === true)")
                  b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
                  select-datetime-double(v-model="migration_datetime.value", @done="setDateTime")
                .form-inline(v-else)
                  b-button.mb-2(v-b-modal.select_datetime, variant="outline-secondary", size="sm", title="選択") 選択
                  select-datetime(v-model="migration_datetime.value", @done="setDateTime")
              b-form-group.align-content.mt-2.ml-3(label-cols="5", label-align="right", label-size="sm", :label="migration_datetime.label", :label-class="migration_datetime.label_class")
                b-form-text.mb-2.datetime-text {{showMigrationTime}}
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of migration_datetime.error_msg") {{error_msg}}
          div(v-else)
            // ご利用開始希望日
            h5.font-weight-bold.ml-3#preferred-date ご利用開始希望日
            .sub-b-collapse
              b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="preferred_date.label", :label-class="preferred_date.label_class")
                b-form-datepicker.mb-2.datepicker-size(size="sm", v-model="value.preferred_date", :min="preferred_date.min", :max="preferred_date.max", :date-disabled-fn="dateDisabled", :placeholder="preferred_date.placeholder", :hide-header="true", :date-format-options="preferred_date.format_option")
                  //b-form-input.mb-2(size="sm", :type="preferred_date.type", v-model="preferred_date.value")
                b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of preferred_date.error_msg") {{error_msg}}
                b-form-text.description-text-position {{preferred_date.description}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
          // お見積番号
          h5.font-weight-bold.ml-3#estimate お見積番号
          b-form-group.align-content(label-cols="3", label-align="right", label-size="sm", :label="estimate.label", :label-class="estimate.label_class")
            .form-inline
              b-form-text.mr-1 No.
              b-form-textarea.mb-2.estimate-size(:state="estimate.error_msg.length === 0 ? null : false", v-model="value.estimate", rows="3")
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of estimate.error_msg") {{error_msg}}
            b-form-text.description-text-position(text-variant="danger") {{estimate.description_1}}
            b-form-text.description-text-position {{estimate.description_2}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
          // 備考
          h5.font-weight-bold.ml-3#remarks 備考
          b-container.sub-b-container
            b-form-group.white-space.align-content(label-cols="12", label-align="left", label-size="sm", :label="remarks.label", :label-class="remarks.label_class")
              b-form-textarea(v-model="value.remarks", rows="4")
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of remarks.error_msg") {{error_msg}}
          //- 空行
          b-form-group(label-cols="3", label-size="sm", style="height: 25px")
          // サービス利用約款など
          h5.font-weight-bold.ml-3 サービス利用約款など
          b-container.sub-b-container
            b-collapse(v-model="neoIsOpen")
              p
                a(href="https://www.desknets.com/cloud/article.pdf", target="_blank") ＞ desknet'sクラウドサービス利用約款
            b-collapse(v-if="value.plan_name !== 'light' && value.plan_name !== 'standard'" v-model="chatIsOpen")
              p
                a(href="https://www.chatluck.com/terms/tos-cloud.pdf", target="_blank") ＞ ChatLuckクラウドサービス利用約款
            p
              b-link(href="/tos.pdf", target="_blank") ＞ クラウド版サポートサイト利用規約
            b-form-textarea.white-space(v-model="provision.value", :disabled="true", rows="6")
            b-form-group.mt-3.mb-0.align-content.text-danger(label-cols="12", label-align="left", label-size="sm", :label="provision.label")
            b-form-checkbox.mx-auto(v-model="value.provision_check", :state="provision_check.error_msg.length === 0 ? null : false", @change="toggleNextButtonDisabled") {{provision_check.label}}
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of provision_check.error_msg") {{error_msg}}
        b-button.float-left.ml-5.my-3(pill, variant="outline-secondary", size="lg", @click="backPage()")
          .float-right.search_message.ml-1.font-weight-bold 戻る
          b-icon.float-left.next-icon(icon="arrow-left-circle")
        b-button.float-right.mr-5.my-3(pill, :variant="nextButtonDisabled ? 'outline-secondary' : 'outline-primary'", size="lg", :disabled="nextButtonDisabled", @click="serviceDetailCheck")
          .float-left.search_message.mr-1.font-weight-bold 次へ
          b-icon.float-right.next-icon(icon="arrow-right-circle")
</template>

<script>
/* eslint-disable */
import SelectDatetime from "@/components/firstOrder/SelectDatetime";
import SelectDatetimeDouble from "@/components/firstOrder/SelectDatetimeDouble";
import Api from "@/repositories/api";

const c204SubdomainCheckRepository = Api.get("c204SubdomainCheck")

const f201FirstOrderRepository = Api.get("f201FirstOrder");

export default {
  name: "InputServiceContentsForm",
  components: {
    SelectDatetime,
    SelectDatetimeDouble
  },
  props: {
    value: { type: Object, required: false }
  },
  // 画面表示時処理(DOM作成前に実行)
  created() {
    // AppSuiteを含むプランの場合、AppSuiteのユーザー数を初期値にする
    if (['standard', 'premium'].indexOf(this.value.plan_name) !== -1) {
      this.value.app_suite_user = null;
    }

    // 今日の日付の取得
    let currentDate = new Date();

    // 開始日(Dateオブジェクト)
    let startDate = new Date(currentDate);
    // 開始日(YYYY-MM-DD)
    let formedStartDate = ''

    // 祝日データを取得
    const holiday = this.getHolidays()

    // 本日から空ける必要のある営業日数(N日目が開始日)
    let preparationCount = this.getPreparationDayCount()

    // datepickerの最小値を作成
    for (let i = 0; i <= preparationCount; i++) {
      // 最後の日が休日の場合に開始日を進める必要があるので、比較にイコールを含む

      // YYYY-MM-DD の形式にする
      formedStartDate =  startDate.getFullYear()
          + "-" + ("00" + (startDate.getMonth() + 1)).slice(-2)
          + "-" + ("00" + startDate.getDate()).slice(-2)

      // 土曜日または日曜日または祝日の場合はスキップ
      if (startDate.getDay() === 6 || startDate.getDay() === 0 || holiday.includes(formedStartDate) === true) {
        i--
      }

      // 最終日ではない場合は翌日へ
      if (i < preparationCount) {
        startDate.setDate(startDate.getDate() + 1)
      }
    }
    this.preferred_date.min = formedStartDate

    // datepickerの最大値を作成
    let maxDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
    this.preferred_date.max = maxDate.getFullYear()
        + "-" + ("00" + (maxDate.getMonth() + 1)).slice(-2)
        + "-" + ("00" + maxDate.getDate()).slice(-2)
    //
    //---------------------------------------------------------
    // サービス内容入力画面に戻ってきたとき、元々開いていたオプションを開く
    //---------------------------------------------------------
    //
    // NEOを含むプランが選択されていた場合、desknet'sNEOのオプションを開く
    if (['light', 'standard', 'premium', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
      this.neoOpen(this.value.plan_user)
    }

    // オプションサービス チェックボックスを開く
    if (this.value.option_service === true) {
      this.toggleOptionService()
      // CLOUZAチェックボックスを開く
      if (this.value.clouza_check === true) {
        this.toggleClouza()
      }
      // ディスク増設チェックボックスを開く
      if (this.value.option_disk === true) {
        this.toggleDisk()
      }
      // Sync for smartphoneチェックボックスを開く
      if (this.value.option_sync === true) {
        this.toggleSync()
      }
      // desknet'sドライブ ディスク増設チェックボックスを開く
      if (this.value.option_dn_drive === true) {
        this.toggleDnDrive()
      }
    }

    // セキュリティオプションを開く
    if (this.value.security_option === true) {
      this.toggleSecurityOption()

      // BASIC認証を開く
      if (this.value.basic_auth === true) {
        this.toggleBasic()
      }
      // 接続元IPアドレス制限を開く
      if (this.value.ip_restrictions === true) {
        this.toggleIpRestrictions()
      }
      // セキュアブラウザを開く
      if (this.value.secure_browser === true) {
        this.toggleSecureBrowser()
      }
      // クライアント認証を開く
      if (this.value.client_auth === true) {
        this.toggleClientAuth()
      }
    }

    // メールサービスチェックボックスを開く
    if (this.value.mail_service === true) {
      this.toggleMailService()
      // WebARENAチェックボックスを開く
      if (this.value.web_arena === true) {
        this.toggleWebArena()
      }
      // CYBERMAILΣチェックボックスを開く
      if (this.value.cyber === true) {
        this.toggleCyber()
      }
    }

    // メールセキュリティサービスチェックボックスを開く
    if (this.value.mail_security_service === true) {
      this.toggleMailSecurityService()
      // MAILGATES Σチェックボックスを開く
      if (this.value.mailgates === true) {
        this.toggleMailgates()
      }
    }

    // 無料お試し版からのデータ移行を開く
    if (this.value.migration === true) {
      this.toggleMigration()
    }

    // ChatLuckを含むプランが選択されていた場合、ChatLuckオプションを開く
    if (['premium', 'chatplus', 'chatluck'].indexOf(this.value.plan_name) !== -1) {
      this.chatOpen(this.value.plan_user)
    }

    // ChatLuckオプションサービスを開く
    if (this.value.chat_option_service === true) {
      this.toggleChatOptionService()
      // ディスク増設を開く
      if (this.value.chat_option_disk === true) {
        this.toggleChatDisk()
      }
    }

    // ChatLuckセキュリティオプションを開く
    if (this.value.chat_security_option === true) {
      this.toggleChatSecurityOption()
      // ChatLuck Basic認証を開く
      if (this.value.chat_basic_auth === true) {
        this.toggleChatBasic()
      }
      // ChatLuck接続元IPアドレス制限を開く
      if (this.value.chat_ip_restrictions === true) {
        this.toggleChatIpRestrictions()
      }
    }

    // ChatLuck無料お試し版からのデータ移行を開く
    if (this.value.chat_migration === true) {
      this.toggleChatMigration()
    }

    // サービス利用規約がチェックされている場合、「次へ」ボタンを有効にする
    if (this.value.provision_check === true) {
      this.toggleNextButtonDisabled()
    }

    //
    //------------------------------
    // アンカーに選択されている箇所を開く
    //------------------------------
    // neoかchatかを取得
    const service_type = this.$route.params.service_type;

    // アンカーを取得
    const anchor = this.$route.params.anchor;

    // neoの場合
    // 入力欄を開く
    if (service_type === "neo") {
      // neoのサービス内容を開く
      this.neoIsOpen = true;
    }
    else if (service_type === "chat") {
      // chatのサービス内容を開く
      this.chatIsOpen = true;
    }
    else if (service_type === "both") {
      // 両方のサービス内容を開く
      this.neoIsOpen = true;
      this.chatIsOpen = true;
    }

    // アンカーの場所へ遷移後の追加処理
    switch (anchor) {
      // オプションサービス
      case "neo_option_service":
        // チェックボックスにチェックを付けて項目を開く
        this.option_service.checked = true;
        this.optionServiceIsOpen = true;

        break;
      // セキュリティオプション
      case "neo_security_option":
        // チェックボックスにチェックを付けて項目を開く
        this.security_option.checked = true;
        this.securityOptionIsOpen = true;

        break;
      // メールサービス
      case "neo_mail_service":
        // チェックボックスにチェックを付けて項目を開く
        this.mail_service.checked = true;
        this.mailServiceIsOpen = true;

        break;
      // メールセキュリティサービス
      case "neo_mail_security_service":
        // チェックボックスにチェックを付けて項目を開く
        this.mail_security_service.checked = true;
        this.mailSecurityServiceIsOpen = true;

        break;
      // 無料お試し版からのデータ移行
      case "neo_migration_url":
        // チェックボックスにチェックを付けて項目を開く
        this.migration.checked = true;
        this.migrationIsOpen = true;

        break;
      // オプションサービス
      case "chat_option_service":
        // チェックボックスにチェックを付けて項目を開く
        this.chat_option_service = true;
        this.chatOptionServiceIsOpen = true;

        break;
      // セキュリティオプション
      case "chat_security_option":
        // チェックボックスにチェックを付けて項目を開く
        this.chat_security_option = true;
        this.chatSecurityOptionIsOpen = true;

        break;
      // 無料お試し版からのデータ移行
      case "chat_migration_url":
        // チェックボックスにチェックを付けて項目を開く
        this.chat_migration.checked = true;
        this.chatMigrationIsOpen = true;

        break;
      // 無料お試し版からのデータ移行作業日時
      case "migration_date":
        this.anyIsOpen = true;
        // 「無料お試し版からのデータ移行」のチェックボックスにチェックを付けて項目を開く
        // チェックがある方の項目を開く
        if (service_type === "neo") {
          this.migration.checked = true;
          this.migrationIsOpen = true;
        }
        else if (service_type === "chat") {
          this.chat_migration.checked = true;
          this.chatMigrationIsOpen = true;
        }
        else if (service_type === "both") {
          this.migration.checked = true;
          this.migrationIsOpen = true;
          this.chat_migration.checked = true;
          this.chatMigrationIsOpen = true;
        }

        break;
      // ご利用開始希望日
      case "preferred_date":
        this.anyIsOpen = true;

        break;
      default:
    }
  },
  // アンカーまでスクロールさせる(DOM作成後に実行)
  mounted() {
    // ハッシュ値を取得
    const hash = this.$route.hash;

    // アンカーのハッシュがある場合
    if (hash && hash.match(/^#.+$/)) {
      // 対象のIDまでスクロール
      document.getElementById(this.$route.hash.replace(/^#/, '')).scrollIntoView();
    }
  },
  data() {
    // 必須のラベル
    const required_label_class = "py-05 mb-4 required-label-after";

    // 任意のラベル
    const elective_label_class = "py-05 mb-4 elective-label-after";

    return {
      neoIsOpen: false,
      chatIsOpen: false,
      anyIsOpen: false,
      optionServiceIsOpen: false,
      optionClouzaIsOpen: false,
      optionDiskIsOpen: false,
      optionSyncIsOpen: false,
      optionDnDriveIsOpen: false,
      securityOptionIsOpen: false,
      basicIsOpen: false,
      ipRestrictionsIsOpen: false,
      secureBrowserIsOpen: false,
      clientAuthIsOpen: false,
      mailServiceIsOpen: false,
      webArenaIsOpen: false,
      cyberIsOpen: false,
      mailSecurityServiceIsOpen: false,
      mailgatesIsOpen: false,
      migrationIsOpen: false,
      chatOptionServiceIsOpen: false,
      chatOptionDiskIsOpen: false,
      chatSecurityOptionIsOpen: false,
      chatBasicIsOpen: false,
      chatIpRestrictionsIsOpen: false,
      chatMigrationIsOpen: false,
      option_disk_sum: 20,
      option_dn_drive_disk_sum: 20,
      secureBrowserTerminalDisabled: true,
      chat_option_disk_sum: 20,
      nextButtonDisabled: true,
      plans: {
        'light': { title: 'ライト', price: 660, services:['neo'], plan:'light'},
        'standard': { title: 'スタンダード', price: 880, services:['neo', 'appsuite'], plan:'standard' },
        'premium': { title: 'プレミアム', price: 1100, services:['neo', 'appsuite', 'chatluck'], plan:'premium' },
        'chatplus': { title: 'チャットプラス', price: 836, services:['neo', 'chatluck'], plan:'chatplus' },
        'chatluck': { title: 'ChatLuck', price: 330, services:['chatluck'], plan:'chatluck' },
        '': { title: '', price: '', services: [], plan: '' }
      },
      plan: {
        label: "ユーザー数",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
        maxlength: 5
      },
      chat: {
        label: "ユーザー数",
        label_class: "",
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: []
      },
      app_suite: {
        label: "ユーザー数",
        label_class: elective_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーから、desknet's NEOの契約ユーザー数までのご契約となります。\n" +
          "※ご契約単位は1ユーザー単位です。",
        error_msg: []
      },
      web_conferencing: {
        label: "会議室数",
        label_class: elective_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最低契約会議室は1会議室から、最大10会議室までのご契約となります。\n" +
          "※ご契約単位は1会議室単位です。",
        error_msg: []
      },
      option_service: {
        checked: false,
        error_msg: []
      },
      // RoomMgr
      option_room_mgr: {
        checked: false,
        label: "RoomMgr（￥22,000/月）",
        description: "※SAML認証との併用はできません。\n" +
            "※クライアント認証オプションと併用する場合、RoomMgrへログインするタブレットへ証明書をインストールしていただくか、\n" +
            "タブレットからの接続は特定のIPアドレス/ネットワークからとして、クライアント認証を除外する手続きを行ってください。",
        error_msg: []
      },
      option_expense_settlement: {
        checked: false,
        label: "交通費・経費精算（1ユーザー￥110/月）",
        description: "※desknet's NEOのご契約ユーザー数と同数でのご契約となります。",
        error_msg: []
      },
      clouza_check: {
        checked: false,
        label: "タイムカード＋CLOUZA（10ユーザー￥2,200/月）",
        error_msg: []
      },
      clouza_input: {
        label: "ユーザー数",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は20ユーザーです。\n" +
          "※ご契約単位は10ユーザー単位です。",
        error_msg: []
      },
      clouza_company_code: {
        label: "会社コード",
        label_class: elective_label_class,
        type: "text",
        //value: "",
        placeholder: "",
        description: "※CLOUZAお試し環境からの引き継ぎがある場合のみ入力してください。",
        error_msg: []
      },
      paid_leave_option: {
        checked: false,
        label: "有休管理＋申請承認オプション 　(10ユーザー￥1,650/月)",
        description: "※タイムカード＋CLOUZA本体の契約ユーザー数と同数でのご契約となります。",
        error_msg: []
      },
      option_disk: {
        checked: false,
        label: "ディスク増設（20GBあたり￥2,200/月）",
      },
      option_disk_size: {
        label: "増設容量",
        label_class: required_label_class,
        type: "text",
        //value: "1",
        error_msg: []
      },
      option_sync: {
        checked: false,
        label: "Sync for smartphones（1ユーザー￥220/月）",
        error_msg: []
      },
      option_sync_input: {
        label: "ユーザー数",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: []
      },
      option_dn_drive: {
        checked: false,
        label: "desknet'sドライブ ディスク増設（20GBあたり￥2,200/月）",
      },
      option_dn_drive_disk_size: {
        label: '増設容量',
        label_class: required_label_class,
        type: 'text',
        error_msg: []
      },
      security_option: {
        checked: false,
      },
      basic_auth: {
        checked: false,
        label: "BASIC認証（無償）",
        error_msg: []
      },
      basic_auth_user: {
        label: "ユーザーID",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角英数字）",
        error_msg: []
      },
      basic_auth_password: {
        label: "パスワード",
        label_class: required_label_class,
        type: "password",
        //value: "",
        placeholder: "（半角英数字）",
        error_msg: []
      },
      basic_auth_ip: {
        label: "認証を除外するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "elective-label-after",
        //value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24",
        error_msg: []
      },
      ip_restrictions: {
        label: "接続元IPアドレス制限（無償）",
        checked: false,
        error_msg: []
      },
      ip_restrictions_ip: {
        label: "接続を許可するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "required-label-after",
        //value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続を許可する：192.0.2.201\n" +
          "　特定のネットワークからの接続を許可する：192.0.2.0/24",
        error_msg: []
      },
      secure_browser: {
        label: "セキュアブラウザ（1ユーザー￥110/月 または 1デバイス￥385/月）",
        checked: false,
        error_msg: []
      },
      secure_browser_terminal: {
        label: "端末認証",
        label_class: required_label_class,
        //value: "01",
        options: [
          {
            value: "01",
            text: "端末認証なし",
            description: "※desknet's NEOのご契約ユーザー数と同数でのご契約となります。",
          },
          {
            value: "02",
            text: "端末認証あり",
            description: "※最低契約デバイス数は5デバイスです。\n" +
              "※ご契約単位は1デバイス単位です"
          }
        ],
        error_msg: []
      },
      secure_browser_device: {
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        error_msg: []
      },
      secure_browser_ip: {
        label: "セキュアブラウザを適用しないIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "required-label-after",
        //value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24",
        error_msg: []
      },
      client_auth: {
        label: "クライアント認証（1デバイス￥220/月）",
        checked: false,
        error_msg: []
      },
      client_auth_input: {
        label: "デバイス数",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最低契約デバイス数は5デバイスです。\n" +
          "※ご契約単位は1デバイス単位です。",
        error_msg: []
      },
      client_auth_ip: {
        label: "認証を除外するIPアドレス(1行に1件ずつ記入、最大50件まで)",
        label_class: "elective-label-after",
        //value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24",
        error_msg: []
      },
      mail_service: {
        label: "メールサービス",
        checked: false,
      },
      web_arena: {
        label: "WebARENA（1アカウント￥220/月）",
        checked: false,
        error_msg: []
      },
      web_arena_domain: {
        label: "利用ドメイン名",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角英数字）",
        description: "※半角英数字および「-」と「.」のみで入力してください",
        error_msg: []
      },
      web_arena_input: {
        label: "アカウント数",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最小25～最大1000アカウント迄ご利用可能です。\n※ご契約単位は1アカウント単位です。",
        error_msg: []
      },
      cyber: {
        label: "CYBERMAILΣ（1アカウント￥220～/月、初期￥55,000～）",
        checked: false,
        error_msg: []
      },
      cyber_input: {
        label: "アカウント数",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "（半角数字）",
        description: "※最小50アカウントからご利用可能です。\n※ご契約単位は10アカウント単位です。",
        error_msg: []
      },
      cyber_capacity: {
        label: "メールボックス容量",
        label_class: required_label_class,
        //value: "00",
        options: [
          { value: "00", name: "（容量を選択してください）" },
          { value: "01", name: "5GB" },
          { value: "02", name: "10GB" },
          { value: "03", name: "50GB" },
          { value: "04", name: "100GB" }
        ],
        error_msg: []
      },
      cyber_option: {
        label: "オプション",
        label_class: elective_label_class,
        options: [
          { label: "情報漏えい対策(有償)", value: "01", description: "※メール誤送信対策機能(一時保留、上長承認・自己承認、添付ファイル全文チェック)および個人情報漏洩 対策機能(BCC強制変換、個人情報流出防止、添付ファイル自動暗号化、添付ファイル分離配送)を利用できます。" },
          { label: "添付ファイル暗号化・分離(有償)", value: "02", description: "※添付ファイル自動暗号化および添付ファイル分離配送を利用できます。" },
          {
            label: "メールアーカイブ＆監査(有償)",
            //value: "03",
            options: [
              {value: "00", name: "（保存期間を選択してください）"},
              {value: "01", name: "5年保存"},
              {value: "02", name: "7年保存"},
            ],
            option_value: "00",
            error_msg: []
          },
          { label: "クラウド型サンドボックス(有償)", value: "04", description_1: "上記以外のオプション(メール無害化など)をご希望のお客様は、弊社まで", description_2: "ください。" }
        ],
        error_msg: []
      },
      mail_security_service: {
        label: "メールセキュリティサービス",
        checked: false,
      },
      mailgates: {
        label: "MAILGATES Σ（1アカウント￥110～/月、初期￥55,000～）",
        checked: false,
        error_msg: []
      },
      mailgates_domain: {
        label: "利用ドメイン名",
        label_class: required_label_class,
        description: "※半角英数字および「-」と「.」のみで入力してください。",
        placeholder: '（半角英数字）',
        error_msg: []
      },
      mailgates_input: {
        label: "アカウント数",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角数字）",
        description: "※最小50アカウントからご利用可能です。\n※ご契約単位は10アカウント単位です。",
        error_msg: []
      },
      mailgates_option: {
        label: "オプション",
        label_class: required_label_class,
        options: [
          { label: "アンチウイルス・スパム＋サンドボックス", value: "01", description: "※ウイルス・迷惑メール対策(アンチウイルス・スパム)、フィッシング対策(URLフィルタリング)、なりすまし対策(SPF DKIM DMARC設定)、BEC対策(アドレス詐称判定)、サンドボックスを利用できます。" },
          { label: "誤送信対策・審査", value: "02", caution: '添付ファイル暗号化・分離と同時に申込みできません。', description: "※メール誤送信対策機能(一時保留、上長承認・自己承認、添付ファイルの全文チェック)および個人情報漏洩対策機能(BCC強制変換、個人情報流出防止、添付ファイル自動暗号化、添付ファイル分離配送)を利用できます。" },
          { label: "添付ファイル暗号化・分離", value: "03", caution: '誤送信対策・審査と同時に申込みできません。',  description: "※添付ファイル自動暗号化および添付ファイル分離配送を利用できます。" }
        ],
        error_msg: []
      },
      preferred_date: {
        label: "希望日",
        label_class: required_label_class,
        value: "",
        placeholder: "（カレンダーから選択）",
        min: "",
        max: "",
        format_option: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
        description: "※弊社でお申込書受領後、3～4営業日ほどお時間いただいております。\n" +
          "※ご利用開始希望日が弊社休業日の場合、翌営業日のご希望として承ります。\n" +
          "※ご利用開始希望日は目安として承りますので、ご希望に添えない場合がございます。ご了承ください。",
        error_msg: []
      },
      sub_domain: {
        label: "サブドメイン名",
        label_class: required_label_class,
        type: "text",
        //value: "",
        placeholder: "",
        description: "※お客さまを識別するアクセスURLの一部になります。\n" +
          "※半角ハイフンのサブドメイン先頭および末尾への使用、また半角アンダースコアの使用はできません。",
        error_msg: [],
      },
      estimate: {
        label: "お見積番号",
        label_class: elective_label_class,
        //value: "",
        description_1: "既に弊社から見積を取得されている場合、必ずご記入ください。",
        description_2: "※見積書が複数ある場合、改行区切りですべての見積もり番号をご記入ください。",
        error_msg: []
      },
      remarks: {
        label: "弊社への連絡事項などございましたら、こちらにご記入ください。",
        label_class: "elective-label-after",
        //value: "",
        error_msg: []
      },
      provision: {
        label: "お申込みいただくにあたり、各種サービス約款および上記の各条項にご同意ください。",
        value: "個人情報の取得目的\n" +
          "１．当社は、当Webサイトにおいて、下記に記載する目的でお客さまより個人情報をご提供いただきます。\n" +
          "　①　お客さまからの資料請求、お問合せ、製品購入申込み等々に対する当社からの返信・送付\n" +
          "　②　当社からの製品情報（新製品やバージョンアップなど）、キャンペーン情報、セミナー情報などのご案内のダイレクトメール（電子メールを含む）の送付および製品に関するその他の情報提供\n" +
          "　③　サービスと製品開発のための統計用データとしての利用\n" +
          "　④　カスタマーハラスメント等への対応・事実確認\n" +
          "\n" +
          "\n" +
          "反社会的勢力の排除について\n" +
          "１．お客さまは、現在または将来にわたって、下記のいずれにも該当しないことを表明、確約するものとします。\n" +
          "　①　暴力団\n" +
          "　②　暴力団員\n" +
          "　③　暴力団員でなくなった時から５年を経過しない者\n" +
          "　④　暴力団準構成員\n" +
          "　⑤　暴力団関係企業\n" +
          "　⑥　総会屋等、社会運動標ぼうゴロまたは特殊知能暴力集団\n" +
          "　⑦　その他上記各号に準ずるもの\n" +
          "２．お客さまは、自らまたは第三者を利用し、下記のいずれかに該当する行為を行わないことを表明、確約するものとします。\n" +
          "　①　暴力的な要求行為\n" +
          "　②　法的な責任を超えた不当な要求行為\n" +
          "　③　取引に関して、脅迫的な言動をし、または暴力を用いる行為\n" +
          "　④　風説を流布し、偽計または威力を用いて当社の信用を毀損し、または当社の業務を妨害する行為\n" +
          "　⑤　その他上記各号に準ずる行為\n" +
          "３．お客さまが上記各項のいずれかに反したと認められることが判明した場合、および上記各項の表明、確約が虚偽の申告であることが判明した場合、当社は、催告その他の手続を要しないで、契約の解除その他の当社が必要と判断する対応をとることができます。\n" +
          "４．お客さまは、前項による契約の解除等について、一切異議を申し立てず、また賠償ないし補償を求めないとともに、これより当社に損害が生じた場合は、これを賠償するものします。\n" +
          "\n" +
          "\n" +
          "管轄裁判所\n" +
          "１．本条項に基づく契約は日本法に準拠し、お客さまと当社の間で訴訟の必要が生じた場合には、訴額に応じて、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。"
      },
      provision_check: {
        checked: false,
        label: "上記の条項に同意します。",
        error_msg: []
      },
      migration: {
        checked: false,
        label: "希望する",
        description: "※移行作業中は試使用環境が停止します。",
        error_msg: []
      },
      migration_url: {
        label: "試使用環境URL",
        label_class: required_label_class,
        //value: "",
        placeholder: "https://dn06110.dncloudtrial.com/cgi-bin/123456/dneo/dneo.cgi",
        error_msg: []
      },
      migration_choice: {
        label: "作業日時を\n" +
          "選択してください",
        label_class: required_label_class + " white-space",
        error_msg: []
      },
      migration_datetime: {
        label: "選択日時",
        label_class: "py-05 mb-4 datetime-label",
        value: {
          date: '',
          start_time: '',
          end_time: '',
        },
        error_msg: []
      },
      chat_option_service: {
        checked: false,
      },
      chat_option_disk: {
        checked: false,
        label: "ディスク増設（20GBあたり￥1,100/月）",
        error_msg: []
      },
      chat_option_disk_size: {
        label: "増設容量",
        label_class: required_label_class,
        type: "text",
        value: "1",
        error_msg: []
      },
      chat_security_option: {
        checked: false,
      },
      chat_basic_auth: {
        checked: false,
        label: "BASIC認証（無償）",
        error_msg: []
      },
      chat_basic_auth_user: {
        label: "ユーザーID",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角英数字）",
        error_msg: []
      },
      chat_basic_auth_password: {
        label: "パスワード",
        label_class: required_label_class,
        type: "password",
        value: "",
        placeholder: "（半角英数字）",
        error_msg: []
      },
      chat_basic_auth_ip: {
        label: "認証を除外するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "elective-label-after",
        value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続は認証しない：192.0.2.201\n" +
          "　特定のネットワークからの接続は認証しない：192.0.2.0/24",
        error_msg: []
      },
      chat_ip_restrictions: {
        label: "接続元IPアドレス制限（無償）",
        checked: false,
        error_msg: []
      },
      chat_ip_restrictions_ip: {
        label: "接続を許可するIPアドレス（1行に1件ずつ記入、最大50件まで）",
        label_class: "required-label-after",
        value: "",
        description: "※記入例：\n" +
          "　特定のIPアドレスからの接続を許可する：192.0.2.201\n" +
          "　特定のネットワークからの接続を許可する：192.0.2.0/24",
        error_msg: []
      },
      chat_preferred_date: {
        label: "希望日",
        label_class: required_label_class,
        value: "",
        placeholder: "（カレンダーから選択）",
        min: "2021-10-15",
        format_option: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
        description: "※弊社でお申込書受領後、3～4営業日ほどお時間をいただいております。\n" +
          "※ご利用開始希望日が弊社休業日の場合、翌営業日のご希望として承ります。\n" +
          "※ご利用開始希望日は目安として承りますので、ご希望に添えない場合がございます。ご了承ください。",
        error_msg: []
      },
      chat_sub_domain: {
        label: "サブドメイン名",
        label_class: required_label_class,
        type: "text",
        value: "",
        placeholder: "（半角英小文字数字および半角ハイフン）",
        description: "お客様を識別するアクセスURLの一部になります。\n" +
          "※半角ハイフンのサブドメイン先頭および末尾への使用、また半角アンダースコアの使用はできません。",
        error_msg: []
      },
      chat_migration: {
        checked: false,
        label: "希望する",
        description: "※移行作業中は試使用環境が停止します。",
        error_msg: []
      },
      chat_migration_url: {
        label: "試使用環境URL",
        label_class: required_label_class,
        value: "https://trial-v0r3.chatluck.net/cgi-bin/123456/chatlk/chat.cgi",
        placeholder: "https://trial-v0r3.chatluck.net/cgi-bin/123456/chatlk/chat.cgi",
        error_msg: []
      },
      chat_migration_choice: {
        label: "作業日時を選択してください",
        label_class: required_label_class,
      },
      chat_migration_datetime: {
        label: "選択日時",
        label_class: "py-05 mb-4 datetime-label",
        value_tmp: {
          date: '',
          start_time: '',
          end_time: '',
        },
        value: {
          date: '',
          start_time: '',
          end_time: '',
        },
        error_msg: []
      },

      // エラー時のスクロール先
      error_scroll_position: 99,
    }
  },
  methods: {
    /**
     * プランユーザー数が入力された場合の処理
     */
    optionOpen(value) {
      // ライトプランまたはスタンダードプランの場合、desknet's NEOのオプションサービスのフォームを開く
      if(this.value.plan_name === 'light' || this.value.plan_name === 'standard') {
        this.neoOpen(value);
      }
      // プレミアムプランまたはチャットプラスプランの場合、desknet's NEOとChatLuckのオプションサービスのフォームを開く
      else if (this.value.plan_name === 'premium' || this.value.plan_name === 'chatplus') {
        this.neoOpen(value);
        this.chatOpen(value);
      }
      // ChatLuckの場合、ChatLuckのオプションサービスのフォームを開く
      else if (this.value.plan_name === 'chatluck') {
        this.chatOpen(value);
      }
    },
    neoOpen(value) {
      // 今の開閉状態を保存
      let tmp = this.neoIsOpen;

      // ユーザ数が5以下の場合は開かない
      this.neoIsOpen = (value >= 5);
      this.anyIsOpen = (this.neoIsOpen || this.chatIsOpen);

      // 開閉が変わった場合
      if (tmp !== this.neoIsOpen) {
        // 試使用からのデータ移行作業日時を未選択にする
        // 本画面内で使用している値
        this.migration_datetime.value.date       = '';
        this.migration_datetime.value.start_time = '';
        this.migration_datetime.value.end_time   = '';

        // 親画面に返す値
        this.value.migration_date      = "";
        this.value.migration_time_from = null;
        this.value.migration_time_to   = null;
      }
    },
    chatOpen(value) {
      // 今の開閉状態を保存
      let tmp = this.chatIsOpen;

      // ユーザ数が5以下の場合は開かない
      this.chatIsOpen = (value >= 5);
      this.anyIsOpen = (this.neoIsOpen || this.chatIsOpen);

      // 開閉が変わった場合
      if (tmp !== this.chatIsOpen) {
        // 試使用からのデータ移行作業日時を未選択にする
        // 本画面内で使用している値
        this.migration_datetime.value.date       = '';
        this.migration_datetime.value.start_time = '';
        this.migration_datetime.value.end_time   = '';

        // 親画面に返す値
        this.value.migration_date      = "";
        this.value.migration_time_from = null;
        this.value.migration_time_to   = null;
      }
    },
    toggleOptionService() {
      this.optionServiceIsOpen = !this.optionServiceIsOpen;
    },
    toggleClouza() {
      this.optionClouzaIsOpen = !this.optionClouzaIsOpen;
    },
    toggleDisk() {
      this.optionDiskIsOpen = !this.optionDiskIsOpen;
    },
    toggleSync() {
      this.optionSyncIsOpen = !this.optionSyncIsOpen;
    },
    toggleDnDrive() {
      this.optionDnDriveIsOpen = !this.optionDnDriveIsOpen;
    },
    toggleSecurityOption() {
      this.securityOptionIsOpen = !this.securityOptionIsOpen;
    },
    toggleBasic(){
      this.basicIsOpen = !this.basicIsOpen;
    },
    toggleIpRestrictions() {
      this.ipRestrictionsIsOpen = !this.ipRestrictionsIsOpen;
    },
    toggleSecureBrowser() {
      this.secureBrowserIsOpen = !this.secureBrowserIsOpen;
    },
    toggleClientAuth() {
      this.clientAuthIsOpen = !this.clientAuthIsOpen;
    },
    toggleMailService() {
      this.mailServiceIsOpen = !this.mailServiceIsOpen;
    },
    toggleWebArena() {
      this.webArenaIsOpen = !this.webArenaIsOpen;
    },
    toggleCyber() {
      this.cyberIsOpen = !this.cyberIsOpen
    },
    toggleMailSecurityService() {
      this.mailSecurityServiceIsOpen = !this.mailSecurityServiceIsOpen;
    },
    toggleMailgates() {
      this.mailgatesIsOpen = !this.mailgatesIsOpen
    },
    toggleMigration() {
      this.migrationIsOpen = !this.migrationIsOpen;
      // 選択した移行作業日時をクリアする
      this.value.migration_date = ''
      // 選択したデータ移行作業時刻（から）をクリアする
      this.value.migration_time_from = ''
      // 選択したデータ移行作業時刻（まで）をクリアする
      this.value.migration_time_to = ''
      // ダイアログ用移行作業日時をクリアする
      this.migration_datetime.value.date = ''
    },
    toggleChatOptionService() {
      this.chatOptionServiceIsOpen = !this.chatOptionServiceIsOpen;
    },
    toggleChatDisk() {
      this.chatOptionDiskIsOpen = !this.chatOptionDiskIsOpen;
    },
    toggleChatSecurityOption() {
      this.chatSecurityOptionIsOpen = !this.chatSecurityOptionIsOpen;
    },
    toggleChatBasic() {
      this.chatBasicIsOpen = !this.chatBasicIsOpen;
    },
    toggleChatIpRestrictions() {
      this.chatIpRestrictionsIsOpen = !this.chatIpRestrictionsIsOpen;
    },
    toggleChatMigration() {
      this.chatMigrationIsOpen = !this.chatMigrationIsOpen;
      // 選択した移行作業日時をクリアする
      this.value.migration_date = ''
      // 選択したデータ移行作業時刻（から）をクリアする
      this.value.migration_time_from = ''
      // 選択したデータ移行作業時刻（まで）をクリアする
      this.value.migration_time_to = ''
      // ダイアログ用移行作業日時をクリアする
      this.migration_datetime.value.date = ''
    },
    toggleNextButtonDisabled() {
      this.nextButtonDisabled = !this.nextButtonDisabled;
    },
    changeSumSize(value) {
      // 数値ではない場合、0を出力する
      if (isNaN(value)) {
        this.option_disk_sum = 0;
      }
      // 数値の場合は通常通り計算する
      else {
        this.option_disk_sum = value * 20;
      }
    },
    driveChangeSumSize(value) {
      // 数値ではない場合、0を出力する
      if (isNaN(value)) {
        this.option_dn_drive_disk_sum = 0;
      }
      // 数値の場合は通常通り計算する
      else {
        this.option_dn_drive_disk_sum = value * 20;
      }
    },
    chatChangeSumSize(value) {
      // 数値ではない場合、0を出力する
      if (isNaN(value)) {
        this.chat_option_disk_sum = 0;
      }
      // 数値の場合は通常通り計算する
      else {
        this.chat_option_disk_sum = value * 20;
      }
    },
    secureBrowserTerminalChange(value) {
      // 端末認証なし
      if (value === "01") {
        // デバイス数を空にする
        this.value.secure_browser_device = "";

        // デバイス数の入力ができないようにする
        this.secureBrowserTerminalDisabled = true;
      }
      // 端末認証あり
      else {
        // デバイス数の入力ができるようにする
        this.secureBrowserTerminalDisabled = false;
      }
    },
    // datepickerの土日を選択不可にする
    dateDisabled(ymd, date) {
      // 曜日を取得する（日曜日 - 土曜日：0 - 6）
      const iWeekday = date.getDay()

      // 各日付の「YYYY-mm-dd」形式
      const day = date.getFullYear()
          + "-" + ("00" + (date.getMonth() + 1)).slice(-2)
          + "-" + ("00" + date.getDate()).slice(-2)

      // 祝日データを取得
      const holiday = this.getHolidays()

      // 日曜日と土曜日と祝日の場合、選択不可にする
      return iWeekday === 0 || iWeekday === 6 || holiday.includes(day)
    },
    setDateTime() {
      // モーダルでOKボタンが押下されたら、選択した作業日時を設定値にする
      this.value.migration_date = this.migration_datetime.value.date
      // propsのmigration_fromにデータ移行作業時刻（から）を保存する
      this.value.migration_time_from = this.migration_datetime.value.start_time
      // propsのmigration_toにデータ移行作業時刻（まで）を保存する
      this.value.migration_time_to = this.migration_datetime.value.end_time
    },
    setChatDateTime() {
      // モーダルでOKボタンが押下されたら、選択した作業日時を設定値にする
      this.value.chat_migration_date = {...(this.chat_migration_datetime.value_tmp)}
    },
    resetChatDateTime(e) {
      // モーダルでキャンセルされたら、選択した作業日時を設定値に戻す
      if (e.trigger !== 'ok') {
        this.chat_migration_datetime.value_tmp = {...(this.chat_migration_datetime.value)}
      }
    },
    /**
     * サブドメインチェック処理を行う
     */
    domainCheck(order_kind) {
      // 初期化
      let sSubdomainName = ''
      let sSubdomainType = ''

      // お申し込みがNEOの場合
      if (order_kind === 'neo') {
        // サブドメインチェック処理のエラーメッセージを空にする
        this.sub_domain.error_msg = []

        // 変数にNEOのサブドメイン名の値を代入する
        sSubdomainName = this.value.sub_domain
        sSubdomainType = '0'
      }
      // ChatLuckの場合
      else {
        // サブドメインチェック処理のエラーメッセージを空にする
        this.chat_sub_domain.error_msg = []

        // 変数にChatLuckのサブドメイン名の値を代入する
        sSubdomainName = this.value.chat_sub_domain
        sSubdomainType = '1'
      }
      // サブドメインチェック処理を呼び出す
      c204SubdomainCheckRepository.get(encodeURIComponent(sSubdomainName), sSubdomainType)
       .catch((err) => {
         // 共通のエラー処理
         this.apiError(err, '入力チェック処理', 'FirstOrder')

         // エラーメッセージを生成する
         if (err.response !== null && err.response !== undefined) {
           const errList = err.response.data.error_list
           let target = order_kind === 'neo' ? 'sub_domain' : 'chat_sub_domain'
           errList.forEach((sErrorMessage) => {
             this.responseErrorMessage(target, sErrorMessage.error_msg)
           })
         }
       })
    },
    serviceDetailCheck() {
      // 次へボタンをロックする
      this.nextButtonDisabled = true;

      // エラー時のスクロール先をリセット
      this.error_scroll_position = 99;

      // 表示されているエラーの消去
      this.resetErrorMsg()

      // 入力のある項目をリクエストデータに追加していく
      let submitData = this.createRequestData();

      // API呼び出し
      f201FirstOrderRepository.getServiceDetailCheck(submitData)
      .then((res) => {
        if (res.data.success === true) {
          // 大項目がチェックされていない場合、直下のチェックボックスのチェックを外す
          this.uncheckChildren()

          // お客様情報入力画面に移動
          this.$router.push({
            name: "FirstOrderCustomerInfo",
            query: {
              token: this.value.token
            }
          });
        }
      })
      .catch((err) => {
        // 次へボタンをロックを解除する
        this.nextButtonDisabled = false;

        // 共通のエラー処理
        this.apiError(err, '入力チェック処理', 'FirstOrder')

        // エラーメッセージがある場合
        if (err.response !== null && err.response !== undefined) {
          // エラー要素の取得
          const errList = err.response.data.error_list

          // 各項目にエラーメッセージを設定していく
          errList.forEach((objErr) => {
            // 対象の項目にエラーメッセージセット・スクロール先設定
            this.responseErrorMessage(objErr.target, objErr.error_msg)
          })
        }

        // エラー箇所までスクロールする
        this.scrollErrorPosition();
      })
    },
    // ページを戻る
    backPage() {
      // プラン選択画面へ遷移
      this.$router.push({
        name: "SelectPlan",
        query: {
          token: this.value.token
        }
      })
    },
    // 大項目がチェックされていない場合、直下のチェックボックスのチェックを外す
    uncheckChildren() {
      // NEO
      if (this.neoIsOpen === false) {
        // 無料お試し版からのデータ移行
        this.value.migration = false;
      }

      // Chat
      if (this.chatIsOpen === false) {
        // 無料お試し版からのデータ移行
        this.value.chat_migration = false;
      }

      // NEO オプションサービス
      if (this.value.option_service === false) {
        this.value.option_room_mgr = false
        this.value.option_expense_settlement = false
        this.value.clouza_check = false
        this.value.option_disk = false
        this.value.option_sync = false
        this.value.option_dn_drive = false
      }
      // NEO セキュリティオプション
      if (this.value.security_option === false) {
        this.value.basic_auth = false
        this.value.ip_restrictions = false
        this.value.secure_browser = false
        this.value.client_auth = false
      }
      // NEO メールサービス
      if (this.value.mail_service === false) {
        this.value.web_arena = false
        this.value.cyber = false
      }
      // NEO メールセキュリティサービス
      if (this.value.mail_security_service === false) {
        this.value.mailgates = false
      }
      // ChatLuck オプションサービス
      if (this.value.chat_option_service === false) {
        this.value.chat_option_disk = false
      }
      // ChatLuck セキュリティ
      if (this.value.chat_security_option === false) {
        this.value.chat_basic_auth = false
        this.value.chat_ip_restrictions = false
      }
    },
    createRequestData() {
      let requestData = {}
      // プラン名
      // ChatLuckの場合はプラン名を設定しない
      if (this.value.plan_name !== 'chatluck') {
        requestData.plan_name = this.value.plan_name || ''
      }
      // プランユーザー数
      // ChatLuckの場合はchat_userとしてパラメータをセット
      if (this.value.plan_name === 'chatluck') {
        requestData.chat_user = this.value.plan_user || ''
      }
      // プランを選択している場合はプランユーザー数としてセット
      else if (['light', 'standard', 'premium', 'chatplus'].indexOf(this.value.plan_name) !== -1) {
        requestData.plan_user = this.value.plan_user || ''
      }
      // 業務アプリ作成ツールAppSuite
      if (this.value.app_suite_user !== null && this.value.app_suite_user !== '') {
        requestData.app_suite_user = this.value.app_suite_user
      }
      // desknet's ウェブ会議
      if (this.value.web_conferencing !== null && this.value.web_conferencing !== '') {
        requestData.web_conferencing = this.value.web_conferencing
      }
      // オプションサービス チェックボックス
      if (this.value.option_service === true) {
        requestData.option_service = '1'
      }
      // RoomMgrチェックボックス
      if (this.value.option_room_mgr === true) {
        requestData.option_room_mgr = '1'
      }
      // 交通費・経費精算チェックボックス
      if (this.value.option_expense_settlement === true) {
        requestData.option_expense_settlement = '1'
      }
      // タイムカード＋CLOUZA
      if (this.value.clouza_check === true) {
        requestData.clouza_check = '1'
      }
      // タイムカード＋CLOUZAユーザー数
      if (this.value.clouza_input !== null && this.value.clouza_input !== '') {
        requestData.clouza_input = this.value.clouza_input
      }
      // タイムカード＋CLOUZA会社コード
      if (this.value.clouza_company_code !== null && this.value.clouza_company_code !== '') {
        requestData.clouza_company_code = this.value.clouza_company_code
      }
      // タイムカード＋CLOUZA有休管理＋申請承認オプション
      if (this.value.paid_leave_option === true) {
        requestData.paid_leave_option = '1'
      }
      // ディスク増設 チェックボックス
      if (this.value.option_disk === true) {
        requestData.option_disk  = '1'
      }
      // ディスク増設
      if (this.value.option_disk_size !== null && this.value.option_disk_size !== '' && this.value.option_disk === true) {
        requestData.option_disk_size = this.value.option_disk_size
      }
      // Sync for smartphones
      if (this.value.option_sync === true) {
        requestData.option_sync = '1'
      }
      // Sync for smartphones ユーザ数
      if (this.value.option_sync_input !== null && this.value.option_sync_input !== '') {
        requestData.option_sync_input = this.value.option_sync_input
      }
      // desknet'sドライブ ディスク増設 チェックボックス
      if (this.value.option_dn_drive === true) {
        requestData.option_dn_drive  = '1'
      }
      // desknet'sドライブ ディスク増設
      if (this.value.option_dn_drive_disk_size !== null && this.value.option_dn_drive_disk_size !== '' && this.value.option_dn_drive === true) {
        requestData.option_dn_drive_disk_size = this.value.option_dn_drive_disk_size
      }
      // セキュリティオプション チェックボックス
      if (this.value.security_option === true) {
        requestData.security_option = '1'
      }
      // BASIC認証チェックボックス
      if (this.value.basic_auth === true) {
        requestData.basic_auth = '1'
      }
      // BASIC認証ユーザーID
      if (this.value.basic_auth_user !== null && this.value.basic_auth_user !== '') {
        requestData.basic_auth_user = this.value.basic_auth_user
      }
      // BASIC認証パスワード
      if (this.value.basic_auth_password !== null && this.value.basic_auth_password !== '') {
        requestData.basic_auth_password = this.value.basic_auth_password
      }
      // BASIC認証認証を除外するIPアドレス
      if (this.value.basic_auth_ip !== null && this.value.basic_auth_ip !== '') {
        requestData.basic_auth_ip = this.value.basic_auth_ip
      }
      // 接続を許可するIPアドレス チェックボックス
      if (this.value.ip_restrictions === true) {
        requestData.ip_restrictions = '1'
      }
      // 接続を許可するIPアドレス
      if (this.value.ip_restrictions_ip !== null && this.value.ip_restrictions_ip !== '') {
        requestData.ip_restrictions_ip = this.value.ip_restrictions_ip
      }
      // セキュアブラウザチェックボックス
      if (this.value.secure_browser === true) {
        requestData.secure_browser = '1'
      }
      // セキュアブラウザ端末認証
      if (this.value.secure_browser_terminal !== null && this.value.secure_browser_terminal !== '' && this.value.secure_browser === true) {
        requestData.secure_browser_terminal = this.value.secure_browser_terminal
      }
      // セキュアブラウザデバイス数
      if (this.value.secure_browser_terminal !== null && this.value.secure_browser_terminal !== '' && this.value.secure_browser === true) {
        requestData.secure_browser_device = this.value.secure_browser_device
      }
      // セキュアブラウザセキュアブラウザを適用しないIPアドレス
      if (this.value.secure_browser_ip !== null && this.value.secure_browser_ip !== '') {
        requestData.secure_browser_ip = this.value.secure_browser_ip
      }
      // クライアント認証チェックボックス
      if (this.value.client_auth === true) {
        requestData.client_auth = '1'
      }
      // クライアント認証デバイス数
      if (this.value.client_auth_input !== null && this.value.client_auth_input !== '') {
        requestData.client_auth_input = this.value.client_auth_input
      }
      // クライアント認証認証を除外するIPアドレス
      if (this.value.client_auth_ip !== null && this.value.client_auth_ip !== '') {
        requestData.client_auth_ip = this.value.client_auth_ip
      }
      // メールサービス チェックボックス
      if (this.mailServiceIsOpen === true) {
        requestData.mail_service = '1'
      }
      // WebARENA
      if (this.value.web_arena === true) {
        requestData.web_arena = '1'
      }
      // WebARENA利用ドメイン名
      if (this.value.web_arena_domain !== null && this.value.web_arena_domain !== '') {
        requestData.web_arena_domain = this.value.web_arena_domain
      }
      // WebARENAアカウント数
      if (this.value.web_arena_input !== null && this.value.web_arena_input !== '') {
        requestData.web_arena_input = this.value.web_arena_input
      }
      // CYBERMAILΣチェックボックス
      if (this.value.cyber === true) {
        requestData.cyber_check = '1'
      }
      // CYBERMAILΣアカウント数
      if (this.value.cyber_input !== null && this.value.cyber_input !== '') {
        requestData.cyber_input = this.value.cyber_input
      }
      // CYBERMAILΣメールボックス容量
      if (this.value.cyber_capacity !== null && this.value.cyber_capacity !== '' && this.value.cyber === true) {
        requestData.cyber_capacity = this.value.cyber_capacity
      }
      // CYBERMAILΣオプション
      // オプションが一つでも選択されている場合
      if (this.value.cyber_option.some((option) => option === true)) {
        // 配列を生成
        requestData.cyber_option = []

        // bool値をフラグ値に変換する
        if (this.value.cyber_option[0] === true) {
          requestData.cyber_option.push('00')
        }
        if (this.value.cyber_option[1] === true) {
          requestData.cyber_option.push('01')
        }
        if (this.value.cyber_option[2] === true) {
          requestData.cyber_option.push('02')
        }
        if (this.value.cyber_option[3] === true) {
          requestData.cyber_option.push('03')
        }
      }
      // CYBERMAILΣメールアーカイブ＆監査保存期間
      if (this.value.cyber_keep_period !== null && this.value.cyber_keep_period !== '' && this.value.cyber === true) {
        requestData.cyber_keep_period = this.value.cyber_keep_period
      }
      // メールセキュリティサービス チェックボックス
      if (this.mailSecurityServiceIsOpen === true) {
        requestData.mail_security_service = '1'
      }
      // MAILGATES Σチェックボックス
      if (this.value.mailgates === true) {
        requestData.mailgates_check = '1'
      }
      // MAILGATES Σ利用ドメイン名
      if (this.value.mailgates_domain !== null && this.value.mailgates_domain !== '') {
        requestData.mailgates_domain = this.value.mailgates_domain
      }
      // MAILGATES Σアカウント数
      if (this.value.mailgates_input !== null && this.value.mailgates_input !== '') {
        requestData.mailgates_input = this.value.mailgates_input
      }
      // MAILGATES Σオプション
      if (this.value.mailgates_option.some((option) => option === true)) {
        // 配列を生成
        requestData.mailgates_option = []

        // bool値をフラグ値に変換する
        if (this.value.mailgates_option[0] === true) {
          requestData.mailgates_option.push('01')
        }
        if (this.value.mailgates_option[1] === true) {
          requestData.mailgates_option.push('02')
        }
        if (this.value.mailgates_option[2] === true) {
          requestData.mailgates_option.push('03')
        }
      }
      // ご希望サブドメイン名
      if (this.value.sub_domain !== null && this.value.sub_domain !== '') {
        requestData.sub_domain = this.value.sub_domain
      }
      // 無料お試し版からのデータ移行チェックボックス
      if (this.neoIsOpen === true && this.value.migration === true) {
        requestData.migration = '1'
      }
      // 無料お試し版からのデータ移行試使用環境URL
      if (this.value.migration_url !== null && this.value.migration_url !== '' && this.value.migration === true) {
        requestData.migration_url = this.value.migration_url
      }
      // ChatLuck オプションサービスチェックボックス
      if (this.chatOptionServiceIsOpen === true) {
        requestData.chat_option_service = '1'
      }
      // ChatLuck ディスク増設チェックボックス
      if (this.value.chat_option_disk === true) {
        requestData.chat_option_disk = '1'
      }
      // ChatLuck ディスク増設増設容量
      if (this.value.chat_option_disk_size !== null && this.value.chat_option_disk_size !== '' && this.value.chat_option_disk === true) {
        requestData.chat_option_disk_size = this.value.chat_option_disk_size
      }
      // ChatLuck セキュリティオプションチェックボックス
      if (this.chatSecurityOptionIsOpen === true) {
        requestData.chat_security_option = '1'
      }
      // ChatLuck BASIC認証チェックボックス
      if (this.value.chat_basic_auth === true) {
        requestData.chat_basic_auth = '1'
      }
      // ChatLuck BASIC認証ユーザーID
      if (this.value.chat_basic_auth_user !== null && this.value.chat_basic_auth_user !== '') {
        requestData.chat_basic_auth_user = this.value.chat_basic_auth_user
      }
      // ChatLuck BASIC認証パスワード
      if (this.value.chat_basic_auth_password !== null && this.value.chat_basic_auth_password !== '') {
        requestData.chat_basic_auth_password = this.value.chat_basic_auth_password
      }
      // ChatLuck BASIC認証認証を除外するIPアドレス
      if (this.value.chat_basic_auth_ip !== null && this.value.chat_basic_auth_ip !== '') {
        requestData.chat_basic_auth_ip = this.value.chat_basic_auth_ip
      }
      // ChatLuck 接続元IPアドレス制限チェックボックス
      if (this.value.chat_ip_restrictions === true) {
        requestData.chat_ip_restrictions = '1'
      }
      // ChatLuck 接続元IPアドレス制限接続を許可するIPアドレス
      if (this.value.chat_ip_restrictions_ip !== null && this.value.chat_ip_restrictions_ip !== '') {
        requestData.chat_ip_restrictions_ip = this.value.chat_ip_restrictions_ip
      }
      // ChatLuck ご希望サブドメイン名
      if (this.value.chat_sub_domain !== null && this.value.chat_sub_domain !== '') {
        requestData.chat_sub_domain = this.value.chat_sub_domain
      }
      // ChatLuck 無料お試し版からのデータ移行
      if (this.chatIsOpen === true && this.value.chat_migration === true) {
        requestData.chat_migration = '1'
      }
      // ChatLuck 無料お試し版からのデータ移行試使用環境URL
      if (this.value.chat_migration_url !== null && this.value.chat_migration_url !== '' && this.value.chat_migration === true) {
        requestData.chat_migration_url = this.value.chat_migration_url
      }
      // お見積番号
      if (this.value.estimate !== null && this.value.estimate !== '') {
        requestData.estimate = this.value.estimate
      }
      // 備考
      if (this.value.remarks !== null && this.value.remarks !== '') {
        requestData.remarks = this.value.remarks
      }
      // ご利用開始希望日
      if (this.value.preferred_date !== null && this.value.preferred_date !== '') {
        requestData.preferred_date = this.value.preferred_date
      }

      // 無料お試し版からのデータ移行作業日時が必要か
      let needMigration = (this.neoIsOpen === true && this.migrationIsOpen === true) || (this.chatIsOpen === true && this.chatMigrationIsOpen === true);

      // 無料お試し版からのデータ移行作業日付
      // 無料お試し版からのデータ移行作業時刻（から）
      // 無料お試し版からのデータ移行作業時刻（まで）
      if (this.value.migration_date !== null && this.value.migration_date !== '' && needMigration === true) {
        requestData.migration_date = this.value.migration_date
        requestData.migration_time_from = this.value.migration_time_from
        requestData.migration_time_to = this.value.migration_time_to
      }
      // サービス利用約款などチェックボックス
      if (this.value.provision_check === true) {
        requestData.provision_check = '1'
      }

      return requestData
    },
    /**
     * エラーメッセージ・スクロール先をセットする
     *
     * @param target エラーメッセージの対象項目
     * @param msg    セットするエラーメッセージ
     */
    responseErrorMessage(target, msg) {
      switch (target) {
        // プラン名
        case 'plan_name':
          this.plan.error_msg.push(msg)
          this.error_scroll_position = 0;
          break
        // プランユーザー数
        case 'plan_user':
          this.plan.error_msg.push(msg)
          this.error_scroll_position = 0;
          break
        // ビジネスチャットチャットラック ユーザー数
        case 'chat_user':
          this.plan.error_msg.push(msg)
          this.error_scroll_position = 0;
          break
        // 業務アプリ作成ツールAppSuite
        case 'app_suite_user':
          this.app_suite.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 1 ? 1 : this.error_scroll_position;
          break
        // desknet's ウェブ会議
        case 'web_conferencing':
          this.web_conferencing.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 2 ? 2 : this.error_scroll_position;
          break
        // オプションサービス チェックボックス
        case 'option_service':
          this.option_service.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // RoomMgrチェックボックス
        case 'option_room_mgr':
          this.option_room_mgr.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // 交通費・経費精算チェックボックス
        case 'option_expense_settlement':
          this.option_expense_settlement.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // タイムカード＋CLOUZA
        case 'clouza_check':
          this.clouza_check.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // タイムカード＋CLOUZAユーザー数
        case 'clouza_input':
          this.clouza_input.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // タイムカード＋CLOUZA会社コード
        case 'clouza_company_code':
          this.clouza_company_code.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // タイムカード＋CLOUZA有休管理＋申請承認オプション
        case 'paid_leave_option':
          this.paid_leave_option.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // ディスク増設 チェックボックス
        case 'option_disk':
          // this.option_disk.description = msg
          break
        // ディスク増設
        case 'option_disk_size':
          this.option_disk_size.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // Sync for smartphones チェックボックス
        case 'option_sync':
          this.option_sync.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // Sync for smartphones
        case 'option_sync_input':
          this.option_sync_input.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // desknet'sドライブ ディスク増設
        case 'option_dn_drive_disk_size':
          this.option_dn_drive_disk_size.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // BASIC認証チェックボックス
        case 'basic_auth':
          // this.basic_auth.description = msg
          break
        // BASIC認証ユーザーID
        case 'basic_auth_user':
          this.basic_auth_user.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // BASIC認証パスワード
        case 'basic_auth_password':
          this.basic_auth_password.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // BASIC認証認証を除外するIPアドレス
        case 'basic_auth_ip':
          this.basic_auth_ip.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // 接続を許可するIPアドレス チェックボックス
        case 'ip_restrictions':
          break
        // 接続を許可するIPアドレス
        case 'ip_restrictions_ip':
          this.ip_restrictions_ip.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // セキュアブラウザチェックボックス
        case 'secure_browser':
          this.secure_browser.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // セキュアブラウザ端末認証
        case 'secure_browser_terminal':
          this.secure_browser_terminal.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // セキュアブラウザデバイス数
        case 'secure_browser_device':
          this.secure_browser_device.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // セキュアブラウザセキュアブラウザを適用しないIPアドレス
        case 'secure_browser_ip':
          this.secure_browser_ip.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // クライアント認証チェックボックス
        case 'client_auth':
          this.client_auth.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // クライアント認証デバイス数
        case 'client_auth_input':
          this.client_auth_input.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // クライアント認証認証を除外するIPアドレス
        case 'client_auth_ip':
          this.client_auth_ip.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // メールサービス チェックボックス
        case 'mail_service':
          break
        // WebARENA
        case 'web_arena':
          this.web_arena.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // WebARENA利用ドメイン名
        case 'web_arena_domain':
          this.web_arena_domain.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // WebARENAアカウント数
        case 'web_arena_input':
          this.web_arena_input.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // CYBERMAILΣチェックボックス
        case 'cyber':
          this.cyber.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // CYBERMAILΣアカウント数
        case 'cyber_input':
          this.cyber_input.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // CYBERMAILΣメールボックス容量
        case 'cyber_capacity':
          this.cyber_capacity.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // CYBERMAILΣオプション
        case 'cyber_option':
          this.cyber_option.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // CYBERMAILΣメールアーカイブ＆監査保存期間
        case 'cyber_keep_period':
          this.cyber_option.options[2].error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // メールセキュリティサービス チェックボックス
        case 'mail_security_service':
          break
        // MAILGATES Σチェックボックス
        case 'mailgates':
          this.mailgates.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 6 ? 6 : this.error_scroll_position;
          break
        // MAILGATES Σ利用ドメイン名
        case 'mailgates_domain':
          this.mailgates_domain.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 6 ? 6 : this.error_scroll_position;
          break
        // MAILGATES Σアカウント数
        case 'mailgates_input':
          this.mailgates_input.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 6 ? 6 : this.error_scroll_position;
          break
        // MAILGATES Σオプション
        case 'mailgates_option':
          this.mailgates_option.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 6 ? 6 : this.error_scroll_position;
          break
        // ご希望サブドメイン名
        case 'sub_domain':
          this.sub_domain.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 7 ? 7 : this.error_scroll_position;
          break
        // 無料お試し版からのデータ移行チェックボックス
        case 'migration':
          this.migration.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 8 ? 8 : this.error_scroll_position;
          break
        // 無料お試し版からのデータ移行試使用環境URL
        case 'migration_url':
          this.migration_url.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 8 ? 8 : this.error_scroll_position;
          break
        // ChatLuck オプションサービスチェックボックス
        case 'chat_option_service':
          break
        // ChatLuck ディスク増設チェックボックス
        case 'chat_option_disk':
          this.chat_option_disk.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 9 ? 9 : this.error_scroll_position;
          break
        // ChatLuck ディスク増設増設容量
        case 'chat_option_disk_size':
          this.chat_option_disk_size.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 9 ? 9 : this.error_scroll_position;
          break
        // ChatLuck セキュリティオプションチェックボックス
        case 'chat_security_option':
          break
        // ChatLuck BASIC認証チェックボックス
        case 'chat_basic_auth':
          this.chat_basic_auth.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 10 ? 10 : this.error_scroll_position;
          break
        // ChatLuck BASIC認証ユーザーID
        case 'chat_basic_auth_user':
          this.chat_basic_auth_user.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 10 ? 10 : this.error_scroll_position;
          break
        // ChatLuck BASIC認証パスワード
        case 'chat_basic_auth_password':
          this.chat_basic_auth_password.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 10 ? 10 : this.error_scroll_position;
          break
        // ChatLuck BASIC認証認証を除外するIPアドレス
        case 'chat_basic_auth_ip':
          this.chat_basic_auth_ip.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 10 ? 10 : this.error_scroll_position;
          break
        // ChatLuck 接続元IPアドレス制限チェックボックス
        case 'chat_ip_restrictions':
          this.chat_ip_restrictions.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 10 ? 10 : this.error_scroll_position;
          break
        // ChatLuck 接続元IPアドレス制限接続を許可するIPアドレス
        case 'chat_ip_restrictions_ip':
          this.chat_ip_restrictions_ip.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 10 ? 10 : this.error_scroll_position;
          break
        // ChatLuck ご希望サブドメイン名
        case 'chat_sub_domain':
          this.chat_sub_domain.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 11 ? 11 : this.error_scroll_position;
          break
        // ChatLuck 無料お試し版からのデータ移行
        case 'chat_migration':
          this.chat_migration.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 12 ? 12 : this.error_scroll_position;
          break
        // ChatLuck 無料お試し版からのデータ移行試使用環境URL
        case 'chat_migration_url':
          this.chat_migration_url.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 12 ? 12 : this.error_scroll_position;
          break
        // お見積番号
        case 'estimate':
          this.estimate.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 13 ? 13 : this.error_scroll_position;
          break
        // 備考
        case 'remarks':
          this.remarks.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 14 ? 14 : this.error_scroll_position;
          break
        // ご利用開始希望日
        case 'preferred_date':
          this.preferred_date.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 15 ? 15 : this.error_scroll_position;
          break
        // 無料お試し版からのデータ移行作業日付
        case 'migration_date':
          this.migration_datetime.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 16 ? 16 : this.error_scroll_position;
          break
        // 無料お試し版からのデータ移行作業時刻（から）
        case 'migration_time_from':
          this.migration_datetime.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 16 ? 16 : this.error_scroll_position;
          break
        // 無料お試し版からのデータ移行作業時刻（まで）
        case 'migration_time_to':
          this.migration_datetime.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 16 ? 16 : this.error_scroll_position;
          break
        // サービス利用約款などチェックボックス
        case 'provision_check':
          this.provision_check.error_msg.push(msg)
          break
        // desknet'sNEO組み合わせの該当箇所にエラーメッセージを追加
        // 「スタンダードプラン」 + 「AppSuite」
        case 'appsuite_standard':
          this.plan.error_msg.push(msg)
          this.app_suite.error_msg.push(msg)
          this.errorHash = hashIndex === -1 || hashIndex > 3 ? this.neoAnchorList[0] : this.errorHash
          break
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'basic_except_permit':
          this.basic_auth_ip.error_msg.push(msg)
          this.ip_restrictions.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // 「タイムカード＋CLOUZA」 ＋ 「セキュアブラウザ」
        case 'clouza_secure':
          this.clouza_check.error_msg.push(msg)
          this.secure_browser.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // 「BASIC認証」 ＋ 「クライアント認証」
        case 'basic_client':
          this.basic_auth.error_msg.push(msg)
          this.client_auth.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // 「BASIC認証」 ＋ 「セキュアブラウザ」の「端末認証あり」
        case 'basic_secure_device':
          this.basic_auth.error_msg.push(msg)
          this.secure_browser.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // 「BASIC認証」の「除外IPあり」 ＋ 「セキュアブラウザ」の「端末認証なし」
        case 'basic_except_secure_terminal':
          this.basic_auth_ip.error_msg.push(msg)
          this.secure_browser.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // 「接続元IPアドレス制限」 ＋ 「クライアント認証」
        case 'permit_client':
          this.ip_restrictions.error_msg.push(msg)
          this.client_auth.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // 「接続元IPアドレス制限」 ＋ 「セキュアブラウザ」
        case 'permit_secure':
          this.ip_restrictions.error_msg.push(msg)
          this.secure_browser.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break
        // 「クライアント認証」 ＋ 「セキュアブラウザ」
        case 'client_secure':
          this.client_auth.error_msg.push(msg)
          this.secure_browser.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break
        // CYBERMAILの「情報漏えい対策（有償）」+「添付ファイル暗号化・分離（有償）」
        case 'cyber_leak_encode':
          this.cyber_option.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // 「CYBERMAILΣ」　＋ 「MAILGATES Σ」
        case 'cyber_mailgates':
          this.cyber.error_msg.push(msg)
          this.mailgates.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break
        // 「MAILGATES Σ」の「誤送信対策・審査」 ＋ 「MAILGATES Σ」の「添付ファイル暗号化・分離」
        case 'prevent_missend_separation':
          this.mailgates_option.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 6 ? 6 : this.error_scroll_position;
          break
        // ChatLuck組み合わせの該当箇所にエラーメッセージを追加
        // 「BASIC認証」の「除外IPあり」 ＋ 「接続元IPアドレス制限」
        case 'chat_basic_except_permit':
          this.chat_basic_auth_ip.error_msg.push(msg)
          this.chat_ip_restrictions.error_msg.push(msg)
          this.error_scroll_position = this.error_scroll_position > 10 ? 10 : this.error_scroll_position;
          break
        default:
          // スクロール先を画面一番上に設定
          this.error_scroll_position = 99;
          break
      }
    },
    /**
     * エラーの箇所までスクロールさせる
     */
    scrollErrorPosition () {
      // アンカー
      let anchor = "";

      // スクロール箇所毎にアンカーの値を設定
      switch (this.error_scroll_position) {
        // プラン
        case 0:
          anchor = "plan";
          break;
        // AppSuite
        case 1:
          anchor = "app-suite-user";
          break;
        // ウェブ会議
        case 2:
          anchor = "web-conferencing";
          break;
        // オプションサービス（NEO）
        case 3:
          anchor = "neo-option-service";
          break;
        // セキュリティオプション（NEO）
        case 4:
          anchor = "neo-security-option";
          break;
        // メールサービス（NEO）
        case 5:
          anchor = "neo-mail-service";
          break;
        // メールセキュリティサービス（NEO）
        case 6:
          anchor = "neo-mail-security-service";
          break;
        // サブドメイン名（NEO）
        case 7:
          anchor = "neo-sub-domain";
          break;
        // 無料お試し版からのデータ移行試使用環境URL（NEO）
        case 8:
          anchor = "neo-migration-url";
          break;
        // オプションサービス（Chat）
        case 9:
          anchor = "chat-option-service";
          break;
        // セキュリティオプション（Chat）
        case 10:
          anchor = "chat-security-option";
          break;
        // サブドメイン名（Chat）
        case 11:
          anchor = "chat-sub-domain";
          break;
        // 無料お試し版からのデータ移行（Chat）
        case 12:
          anchor = "chat-migration-url";
          break;
        // お見積番号
        case 13:
          anchor = "estimate";
          break;
        // 備考
        case 14:
          anchor = "remarks";
          break;
        // ご利用開始希望日
        case 15:
          anchor = "preferred-date";
          break;
        // 無料お試し版からのデータ移行作業日時
        case 16:
          anchor = "migration-date";
          break;
      }

      // アンカーが設定されている場合
      if (anchor !== "") {
        // アンカーの場所までスクロール
        document.getElementById(anchor).scrollIntoView();
      }
      // アンカーが設定されていない
      else {
        // 画面の一番上へ
        this.pageTopScroll();
      }
    },
    resetErrorMsg() {
      // 全てのエラーメッセージ要素を空にする
      this.plan.error_msg = []
      this.app_suite.error_msg = []
      this.web_conferencing.error_msg = []
      this.option_service.error_msg = []
      this.option_room_mgr.error_msg = []
      this.option_expense_settlement.error_msg = []
      this.clouza_check.error_msg = []
      this.clouza_input.error_msg = []
      this.clouza_company_code.error_msg = []
      this.paid_leave_option.error_msg = []
      this.option_disk_size.error_msg = []
      this.option_sync.error_msg = []
      this.option_sync_input.error_msg = []
      this.option_dn_drive_disk_size.error_msg = []
      this.basic_auth.error_msg = []
      this.basic_auth_user.error_msg = []
      this.basic_auth_password.error_msg = []
      this.basic_auth_ip.error_msg = []
      this.ip_restrictions.error_msg = []
      this.ip_restrictions_ip.error_msg = []
      this.secure_browser.error_msg = []
      this.secure_browser_terminal.error_msg = []
      this.secure_browser_device.error_msg = []
      this.secure_browser_ip.error_msg = []
      this.client_auth.error_msg = []
      this.client_auth_input.error_msg = []
      this.client_auth_ip.error_msg = []
      this.web_arena.error_msg = []
      this.web_arena_domain.error_msg = []
      this.web_arena_input.error_msg = []
      this.cyber.error_msg = []
      this.cyber_input.error_msg = []
      this.cyber_capacity.error_msg = []
      this.cyber_option.error_msg = []
      this.cyber_option.options[2].error_msg = []
      this.mailgates.error_msg = []
      this.mailgates_domain.error_msg = []
      this.mailgates_input.error_msg = []
      this.mailgates_option.error_msg = []
      this.sub_domain.error_msg = []
      this.migration.error_msg = []
      this.migration_url.error_msg = []
      this.chat_option_disk.error_msg = []
      this.chat_option_disk_size.error_msg = []
      this.chat_basic_auth.error_msg = []
      this.chat_basic_auth_user.error_msg = []
      this.chat_basic_auth_password.error_msg = []
      this.chat_basic_auth_ip.error_msg = []
      this.chat_ip_restrictions.error_msg = []
      this.chat_ip_restrictions_ip.error_msg = []
      this.chat_sub_domain.error_msg = []
      this.chat_migration.error_msg = []
      this.chat_migration_url.error_msg = []
      this.estimate.error_msg = []
      this.remarks.error_msg = []
      this.preferred_date.error_msg = []
      this.migration_datetime.error_msg = []
      this.provision_check.error_msg = []
    }
  },
  computed: {
    showMigrationTime() {
      let sDatetime = '選択してください'

      if (this.value.migration_date) {
        // 形式は「2021年11月14日 11:00 - 12:00」
        const arDay = this.value.migration_date.split('-')
        const sTime = this.value.migration_time_from + ':00 - ' + this.value.migration_time_to + ':00'

        sDatetime = arDay[0] + '年' + arDay[1] + '月' + arDay[2] + '日 ' + sTime
      }

      return sDatetime
    },
    showChatMigrationTime() {
      let sDatetime = '選択してください'

      if (this.chat_migration_datetime.value.date) {
        // 形式は「2021年11月14日 11:00 - 12:00」
        const arDay = this.chat_migration_datetime.value.date.split('-')
        const sTime = this.chat_migration_datetime.value.start_time + ':00 - ' + this.chat_migration_datetime.value.end_time + ':00'

        sDatetime = arDay[0] + '年' + arDay[1] + '月' + arDay[2] + '日 ' + sTime
      }

      return sDatetime
    },
  },
}
</script>

<style scoped>
.chat-b-collapse {
  background-color: #f0ffe0;
}
.chat-box {
  height: 110px;
}
.chat-image-size {
  width: 300px;
}
.chat-text-position {
  margin-top: -35px;
}

.datepicker-size {
  width: 210px;
}
::v-deep .datetime-label {
  padding-right: 53px !important;
}
.datetime-text {
  font-size: 1rem;
  margin-top: 1px;
}
.description-text-position {
  margin-top : -3px;
}
.error-text-position {
  margin-top : -6px;
}
.detail-button-size {
  height: 22px;
  font-size: 11px;
  display: flex;
  align-items: center;
}

.estimate-size {
  width: 400px !important;
}

.label-font-size {
  font-size: 16px;
}

.neo-b-collapse {
  background-color: #f2ffff;
}
.neo-image-size {
  width: 300px;
  height: 110px;
}

.option-disk-form-class {
  width: 85px !important;
}

.paid-leave-option-description-font {
  font-size: 12.8px;
}
.paid-leave-option-font {
  font-size: 0.875rem;
}

.sub-b-collapse {
  width: 650px;
  padding: 5px;
  background-color: #ffffd3;
  margin-left: 15px;
}
.sub-b-container {
  width: 650px;
  padding: 5px;
  margin-left: 15px;
}

.white-space {
  white-space: pre-line !important;
}

.logo_desknets {
  width:200px;
  height: auto;
}
.logo_chatluck {
  width:200px;
  height: auto;
}
.logo_appsuite {
  width:200px;
  height: auto;
}
.plan-title-size {
  font-size: 2rem;
}

.error-message-space {
  margin-top: -7px !important;
}
</style>
